<template>
    <div id="deposit">
        <!-- ------------------------------儲值開始------------------------------ -->
        <section class="cm-depositcenter-deposit2022-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">{{$t('support.TopUpBar')}}</div>
            </div>
            

            <form>
                <div class="cm-depositcenter-deposit2022-container">

                    <!-- 1.選擇遊戲、伺服器、角色 -->
                    <div class="cm-depositcenter-deposit2022-step-title">{{$t("deposit.step.selectGameAndServerAndRole")}}</div>
                    <div class="row m-2">
                        <!-- 選擇遊戲 -->
                        <div class="p-md-1 px-5 py-2 col-md-4">
                            <select class="form-control form-control-lg cm-depositcenter-deposit2022-select" 
                                    @change="domSelectGame()" 
                                    v-model="userDepositData.gameCode"
                            >
                                <option active value="">{{$t('deposit.select.ChooseGame')}}</option>
                                <option v-for="(gameCode, gameInfoJsonKey) in Object.keys(programData.gameInfoJson)" :key="gameInfoJsonKey"
                                        :value="gameCode"
                                >
                                    {{programData.gameInfoJson[gameCode].gameName}}
                                </option>
                            </select>
                        </div>
                        <br>

                        <!-- 選擇伺服器分區 -->
                        <div class="p-md-1 px-5 py-2 col-md-4" v-if='Object.keys(this.programData.serverGroupInfoJson).length>1'>
                            <select class="form-control form-control-lg cm-depositcenter-deposit2022-select"
                                    @change="domSelectServerGroup()" 
                                    v-model="userDepositData.serverGroupId"
                            >
                                <option active value="">{{$t('deposit.select.ChooseGameServerGroup')}}</option>
                                <option v-for="(serverGroupId, serverGroupInfoJsonKey) in Object.keys(programData.serverGroupInfoJson)" :key="serverGroupInfoJsonKey"
                                        :value="serverGroupId"
                                >
                                    {{programData.gameInfoJson[userDepositData.gameCode]["serverGroups"][serverGroupId]["serverGroupName"]}}
                                </option>
                            </select>
                            <br v-if='Object.keys(this.programData.serverGroupInfoJson).length>1'>
                        </div>
                        <br>

                        <!-- 選擇伺服器 -->
                        <div class="p-md-1 px-5 py-2 col-md-4">
                            <select class="form-control form-control-lg cm-depositcenter-deposit2022-select"
                                    @change="domSelectServer"
                                    v-model="userDepositData.gameServerNum"
                            >
                                <option active value="">{{$t('deposit.select.ChooseGameServer')}}</option>
                                <option v-for="(serverPk, serverInfoJsonKey) in Object.keys(programData.serverInfoJson)" :key="serverInfoJsonKey"
                                        :value='programData.serverInfoJson[serverPk]["gameServerNum"]'
                                >
                                    {{programData.serverInfoJson[serverPk]["gameServerName"]}}
                                </option>
                            </select>
                        </div>
                        <br>
                    
                        <!-- 選擇角色 -->
                        <div class="p-md-1 px-5 py-2 col-md-4">
                            <select class="form-control form-control-lg cm-depositcenter-deposit2022-select">
                                <option active value="">{{$t('deposit.select.ChooseRole')}}</option>
                                <option v-for="roleInfoJsonKey in Object.keys(programData.roleInfoJson)" :key="roleInfoJsonKey"
                                        :value="programData.roleInfoJson[roleInfoJsonKey]"
                                >
                                    {{programData.roleInfoJson[roleInfoJsonKey]["name"]}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- 1.選擇遊戲、伺服器、角色 -->
                    <div class="cm-depositcenter-deposit2022-step-title">{{$t("deposit.step.selectGameAndServerAndRole")}}(以下為dropdown測試)</div>
                    <div class="row m-2">
                        <!-- 選擇遊戲 -->
                        <div class="p-md-1 px-5 py-2 col-md-4">
                            <b-dropdown
                                class="col p-0 cm-depositcenter-deposit2022-dropdown"
                                :text='(programData.gameInfoJson[userDepositData.gameCode]==undefined) ? $t("deposit.select.ChooseGame"):programData.gameInfoJson[userDepositData.gameCode].gameName'
                            >
                                <b-dropdown-item
                                    @click="domSelectGame('')"
                                    :active='userDepositData.gameCode==""'
                                >
                                    {{$t("deposit.select.ChooseGame")}}
                                </b-dropdown-item>

                                <b-dropdown-item
                                    v-for="(gameCode, gameInfoJsonKey) in Object.keys(programData.gameInfoJson)" :key="gameInfoJsonKey"
                                    :value="gameCode"
                                    @click="domSelectGame(gameCode)"
                                    :active="userDepositData.gameCode==gameCode"
                                >
                                    {{programData.gameInfoJson[gameCode].gameName}}
                                </b-dropdown-item>
                            </b-dropdown>
                            <br>
                        </div>

                        <!-- 選擇伺服器分區 -->
                        <div class="p-md-1 px-5 py-2 col-md-4" v-if='Object.keys(this.programData.serverGroupInfoJson).length>1'>
                            <b-dropdown
                                class="col p-0 cm-depositcenter-deposit2022-dropdown"
                                :text='(userDepositData.serverGroupId=="") ? $t("deposit.select.ChooseGameServerGroup") : programData.gameInfoJson[userDepositData.gameCode]["serverGroups"][userDepositData.serverGroupId]["serverGroupName"]'
                            >
                                <b-dropdown-item
                                    @click="domSelectServerGroup('')"
                                    :active='userDepositData.serverGroupId==""'
                                >
                                    {{$t("deposit.select.ChooseGameServerGroup")}}
                                </b-dropdown-item>

                                <b-dropdown-item
                                    v-for="(serverGroupId, serverGroupInfoJsonKey) in Object.keys(programData.serverGroupInfoJson)" :key="serverGroupInfoJsonKey"
                                    :value="serverGroupId"
                                    @click="domSelectServerGroup(serverGroupId)"
                                    :active="userDepositData.serverGroupId==serverGroupId"
                                >
                                    {{programData.gameInfoJson[userDepositData.gameCode]["serverGroups"][serverGroupId]["serverGroupName"]}}
                                </b-dropdown-item>
                            </b-dropdown>
                            <br>
                        </div>

                        <!-- 選擇伺服器 -->
                        <div class="p-md-1 px-5 py-2 col-md-4">
                            <b-dropdown
                                class="col p-0 cm-depositcenter-deposit2022-dropdown"
                                :text='userDepositData.gameServerName=="" ? $t("deposit.select.ChooseGameServer") : userDepositData.gameServerName'
                            >
                                <b-dropdown-item
                                    @click="domSelectServer('')"
                                    :active='userDepositData.gameServerName==""'
                                >
                                    {{$t("deposit.select.ChooseGameServer")}}
                                </b-dropdown-item>

                                <b-dropdown-item
                                    v-for="(serverPk, serverInfoJsonKey) in Object.keys(programData.serverInfoJson)" :key="serverInfoJsonKey"
                                    :value='programData.serverInfoJson[serverPk]["gameServerNum"]'
                                    @click='domSelectServer(programData.serverInfoJson[serverPk]["gameServerNum"])'
                                    :active='userDepositData.gameServerNum===programData.serverInfoJson[serverPk]["gameServerNum"]'
                                >
                                    {{programData.serverInfoJson[serverPk]["gameServerName"]}}
                                </b-dropdown-item>
                            </b-dropdown>
                            <br>
                        </div>

                        <!-- 選擇角色 -->
                        <div class="p-md-1 px-5 py-2 col-md-4">
                            <b-dropdown
                                class="col p-0 cm-depositcenter-deposit2022-dropdown"
                                :text='userDepositData.gameRoleName=="" ? $t("deposit.select.ChooseRole") : userDepositData.gameRoleName'
                            >
                                <b-dropdown-item
                                    @click.stop="domSelectGameRole('')"
                                    :active='userDepositData.gameRoleName==""'
                                >
                                    {{$t("deposit.select.ChooseRole")}}
                                </b-dropdown-item>

                                <b-dropdown-item
                                    v-for="roleInfoJsonKey in Object.keys(programData.roleInfoJson)" :key="roleInfoJsonKey"
                                    :value="programData.roleInfoJson[roleInfoJsonKey]"
                                    @click.stop='domSelectGameRole(programData.roleInfoJson[roleInfoJsonKey])'
                                    :active='userDepositData.gameRoleName===programData.roleInfoJson[roleInfoJsonKey]["name"]'
                                >
                                    {{programData.roleInfoJson[roleInfoJsonKey]["name"]}}
                                </b-dropdown-item>
                            </b-dropdown>
                            <br>
                        </div>
                    </div>

                    <!-- 特定遊戲提示可儲值Codapay -->
                    <span class="m-2"
                         v-if='userDepositData.gameCode!="" && userDepositData.gameRoleId!="" && userDepositData.gameServerNum!="" && constants.codapay.pushPageArrByGameCode.indexOf(userDepositData.gameCode)>=0'
                         style="cursor:pointer;color:#FFD31C;"
                         @click.prevent="clickDepositCodapay"
                    >
                        {{$t("deposit.turnPage.codapay.url")}}
                    </span>



                    <!-- 2.選擇品項 -->
                    <div class="cm-depositcenter-deposit2022-step-title">{{$t("deposit.step.selectDepositItem")}}</div>
                    <!-- 選擇儲值類型按鈕 -->
                    <div class="d-flex flex-wrap container-fluid" v-if="Object.keys(programData.depositTypeArr).length>1">
                        <div v-for="(depositTypeObj, index) in programData.depositTypeArr" :key="index"
                             :class="[index%2==0 ? 'col-6 row no-gutters d-flex justify-content-center pl-md-5' : 'col-6 row no-gutters d-flex justify-content-center pr-md-5']"
                        >
                            <a href="#"
                               class="cm-depositcenter-deposit2022-packet-type-btn m-md-2 m-0 py-sm-5 px-2"
                               style="text-align: center;"
                               v-bind:style='[userDepositData.depositType===depositTypeObj.codeName ? cssStyle_selectedStyle():{}]'
                               v-on:click.prevent="domSelectDepositType(depositTypeObj.codeName)"
                            >
                                {{depositTypeObj.name}}
                            </a>
                        </div>
                        <br>
                        <br>
                    </div>

                    <!-- 列出所有儲值品項資訊 -->
                    <div class="d-flex flex-wrap px-3 cm-depositcenter-deposit2022-depositItem-container">
                        <!-- 總金額 -->
                        <div class="col-12 p-0 pb-2 cm-depositcenter-deposit2022-depositItem-totalAmount"
                             v-if="userDepositData.depositType==depositTypeSetting.typeObj.Bundle.codeName"
                        >
                            <span>{{$t("deposit.depositItem.prompt.totalAmount")}} {{userDepositData.totalTwdAmount}}</span>
                        </div>

                        <!-- 提示 - 儲值品項期限 -->
                        <div class="p-0 col-12 p-0 pb-2 d-flex flex-wrap container-fluid cm-depositcenter-deposit2022-depositItem-totalAmount"
                             v-if='domPrompt.depositItemInfoPurchasePeriod!=""'
                        >
                            <span style="color:red">
                                {{$t('deposit.depositItem.prompt.purchasePeriod')}}{{this.domPrompt.depositItemInfoPurchasePeriod}}
                            </span>
                            <span style="color:yellow">
                                {{$t('deposit.depositItem.prompt.expiredPrompt')}}
                            </span>
                        </div>
                        <!-- 提示 - 儲值品項超過期限會轉為元寶、複選最多3萬元 -->
                        <div class="p-0 col-12 p-0 pb-2 d-flex flex-wrap container-fluid cm-depositcenter-deposit2022-depositItem-totalAmount"
                             v-if='userDepositData.depositType==depositTypeSetting.typeObj.Bundle.codeName'
                        >
                            <span style="color:yellow">
                                {{$t('deposit.depositItem.prompt.expiredPrompt')}}
                            </span>
                            <span style="color:rgb(3, 252, 240)">
                                {{$t('deposit.depositItem.prompt.creditCardUpperLimit')}}
                            </span>
                        </div>

                        <!-- 列出儲值品項名稱&購買期限 -->
                        <div v-if='userDepositData.gameRoleId==""'>
                            {{$t("deposit.step.hint.selectGameAndServerAndRole")}}
                        </div>
                        <div v-else-if="domControl.ajaxApi.getApkDepositPidsAction.showLoading==false && Object.keys(programData.depositItemInfoArr).length==0">
                            {{$t("deposit.step.selectDepositItem.hint.noDepositItem")}}
                        </div>
                        <div class="col-sm-4 col-6 p-1"
                             v-else-if="domControl.ajaxApi.getApkDepositPidsAction.showLoading==false && Object.keys(programData.depositItemInfoArr).length>0"
                             v-for="(depositItemInfoObj, index) in programData.depositItemInfoArr" :key='index'
                        >
                            <div class="cm-depositcenter-deposit2022-depositItem-btn-container"
                                 v-bind:style='cssStyleChange_depositItemBtn(depositItemInfoObj)'
                                 @click="domSelectDepositItemName(depositItemInfoObj)"
                            >
                                <div class="py-3 px-2 cm-depositcenter-deposit2022-depositItem-btn-itemName">
                                    {{depositItemInfoObj["itemName"]}}
                                </div>
                                <div class="cm-depositcenter-deposit2022-depositItem-btn-underBox">
                                    <div class="cm-depositcenter-deposit2022-depositItem-btn-itemSelected"
                                         v-bind:style='[depositItemInfoObj["domIsSelect"]===false ? {"display":"none"} :{}]'
                                    >
                                        <span class="cm-depositcenter-deposit2022-depositItem-btn-itemSelected-tick">
                                            ﹂
                                        </span>
                                    </div>
                                    <!-- 購買期限 -->
                                    <span class="cm-depositcenter-deposit2022-depositItem-btn-itemExpire"
                                          v-html="depositItemExpireFun(depositItemInfoObj)">
                                    >
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="domControl.ajaxApi.getApkDepositPidsAction.showLoading==true">
                            {{$t("deposit.step.hint.loading")}}
                        </div>
                        <br>
                    </div>


                    
                    <!-- 3.選擇付款方式 -->
                    <div class="cm-depositcenter-deposit2022-step-title">{{$t("deposit.step.selectPayMethod")}}</div>
                    <!-- 列出所有金流相關 -->
                    <div class="px-3 cm-depositcenter-deposit2022-cashflow-categories">
                        <div v-if='userDepositData.gameRoleId==""'>
                            {{$t("deposit.step.hint.selectGameAndServerAndRole")}}
                        </div>
                        <div v-else-if="domControl.ajaxApi.getApkPayMethodsAction.showLoading==false && Object.keys(programData.cashflowSupplierCategoryJson).length==0">
                            {{$t("deposit.step.selectPayMethod.hint.noPayMethod")}}
                        </div>
                        <div v-else-if="domControl.ajaxApi.getApkPayMethodsAction.showLoading==false && Object.keys(programData.cashflowSupplierCategoryJson).length>0"
                             class="cm-depositcenter-deposit2022-cashflow-row"
                             v-for="(cashflowSupplierCategoryObj, cashflowSupplierCategoryIndex) in programData.cashflowSupplierCategoryJson" :key='cashflowSupplierCategoryIndex'
                             v-bind:style='cssStyleChange_cashflowRowDiv(cashflowSupplierCategoryObj)'
                             :id='domEleId_genCashflowEleId(constants.cashflow.cashflowRow, cashflowSupplierCategoryIndex)'
                             
                        >
                            <!-- 金流群組區塊 -->
                            <div class="d-flex flex-row cm-depositcenter-deposit2022-cashflow-category"
                                 v-bind:style='[cashflowSupplierCategoryObj["domCanSelect"]===false ? {"cursor":"not-allowed"} :{}]'
                                 @click.prevent="domSelectCashflowSupplierCategory(cashflowSupplierCategoryIndex, cashflowSupplierCategoryObj)"
                            >
                                <!-- 金流群組左半部 -->
                                <div class="col-lg-8 col-md-8 col p-0 d-md-flex align-items-center">
                                    <!-- 金流群組logo -->
                                    <div v-html='getPayLogoImgHtmlCode(constants.cashflow.cashflowCategory, cashflowSupplierCategoryObj)'></div>
                                    <!-- 金流群組文字 -->
                                    <div class="text-center mx-2 cm-depositcenter-deposit2022-cashflow-name">
                                        {{cashflowSupplierCategoryObj["domDisplayName"]}}
                                    </div>
                                </div>

                                <!-- 金流群組右半部 -->
                                <div class="col-lg-4 col-md-4 col p-0 d-flex flex-row justify-content-center align-items-center cm-depositcenter-deposit2022-cashflow-price-block">
                                    <div v-html="htmlCodeChange_cashflowSupplierCategoryPriceBlockDiv(cashflowSupplierCategoryObj)"></div>
                                </div>
                            </div>

                            <!-- 金流商綜合區塊 -->
                            <div class="cm-depositcenter-deposit2022-cashflow-suppliers"
                                 style="display:none;"
                                 v-if='domDivShow_cashflowSuppliers(cashflowSupplierCategoryObj)===true'
                                 :id="domEleId_genCashflowEleId(constants.cashflow.cashflowSuppliers, cashflowSupplierCategoryIndex)"
                            >
                                <!-- 金流商 -->
                                <div class="row row-col-2 cm-depositcenter-deposit2022-cashflow-supplier"
                                     v-for='(cashflowSupplierNum, cashflowSupplierNumArrIndex) in cashflowSupplierCategoryObj["cashflowSupplierNumArr"]' :key="cashflowSupplierNumArrIndex"
                                     v-bind:style='cssStyleChange_cashflowSupplierDiv(cashflowSupplierCategoryObj, cashflowSupplierNum)'
                                     @click.stop="domSelectCashflowSupplier(cashflowSupplierCategoryIndex, programData.cashflowSupplierJson[cashflowSupplierNum], $event)"
                                >
                                    <!-- 金流商左半部 -->
                                    <div class="col-lg-8 col-md-8 col p-0 d-md-flex align-items-center"
                                         v-if="domDivShow_cashflowSupplier(cashflowSupplierCategoryObj) === true"
                                         v-bind:style='[programData.cashflowSupplierJson[cashflowSupplierNum]["domCanSelect"]===false ? {"cursor":"not-allowed"} :{}]'
                                    >
                                        <div v-html='getPayLogoImgHtmlCode(constants.cashflow.cashflowSupplier, programData.cashflowSupplierJson[cashflowSupplierNum])'>
                                        </div>
                                        <div class="text-center mx-2 cm-depositcenter-deposit2022-cashflow-name">
                                           {{programData.cashflowSupplierJson[cashflowSupplierNum]["domDisplayName"]}}
                                        </div>
                                    </div>

                                    <!-- 金流商右半部 -->
                                    <div class="col-lg-4 col-md-4 col p-0 d-flex flex-row justify-content-center align-items-center cm-depositcenter-deposit2022-cashflow-price-block"
                                         v-if="domDivShow_cashflowSupplier(cashflowSupplierCategoryObj) === true"
                                         v-bind:style='[programData.cashflowSupplierJson[cashflowSupplierNum]["domCanSelect"]===false ? {"border-color":"#939393"} :{}]'
                                    >
                                        <div v-html="htmlCodeChange_cashflowSupplierPriceBlockDiv(cashflowSupplierNum)"></div>
                                    </div>

                                    <!-- 電信商綜合區塊 -->
                                    <div class="col cm-depositcenter-deposit2022-cashflow-vendors"
                                         v-if='Object.keys(programData.cashflowSupplierJson[cashflowSupplierNum]["vendorJson"]).length>0'
                                         v-bind:style="cssStyleChange_cashflowVendorsDiv(cashflowSupplierCategoryObj)"
                                         :id="domEleId_genCashflowEleId(constants.cashflow.vendors, cashflowSupplierNum)"
                                         @click.stop
                                    >
                                        <!-- 電信商 -->
                                        <div class="row row-col-2 m-2 cm-depositcenter-deposit2022-cashflow-vendor"
                                             v-for='(vendorObj, vendorJsonKey) in programData.cashflowSupplierJson[cashflowSupplierNum]["vendorJson"]' :key="vendorJsonKey"
                                             v-bind:style='cssStyleChange_cashflowVendorDiv(vendorObj)' 
                                             @click.stop="domSelectVendor(vendorObj)"
                                        >
                                            <!-- 電信商左半部 -->
                                            <div class="col-lg-8 col-md-8 col p-0 d-md-flex align-items-center"
                                                 v-bind:style='[vendorObj["domCanSelect"]===false ? {"cursor":"not-allowed"} :{}]'
                                            >
                                                <div v-html='getPayLogoImgHtmlCode(constants.cashflow.vendor, vendorObj)'>
                                                </div>
                                                <div class="text-center mx-2 cm-depositcenter-deposit2022-cashflow-name">
                                                   {{vendorObj["vendorName"]}}
                                                </div>
                                            </div>

                                            <!-- 電信商右半部 -->
                                            <div class="col-lg-4 col-md-4 col p-0 d-flex flex-row justify-content-center align-items-center cm-depositcenter-deposit2022-cashflow-price-block"
                                                 v-bind:style='[vendorObj["domCanSelect"]===false ? {"border-color":"#939393"} :{}]'
                                            >
                                                <div v-if='vendorObj["domCanSelect"]===false'
                                                     v-html="htmlCode_cashflowSupplierPriceBlock(constants.cashflow.price.notApplicable)"
                                                >
                                                </div>
                                                <div v-else
                                                     v-html="htmlCode_cashflowSupplierPriceBlock(constants.cashflow.price.showTWDAmount)"
                                                >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- 信用卡非台灣地區提示匯率&可索取發票 -->
                            <div class="col"
                                 v-if='cashflowSupplierCategoryObj["cashflowSupplierCategoryName"]=="信用卡" && userDepositData.cashflowSupplier["payMethodName"]=="信用卡" && userDepositData.cashflowSupplier["invoiceRequired"]==0'
                                 v-html="$t('deposit.payMethod.CreditCard.promptExchangeRate')"
                            >
                            </div>
                        </div>
                        <div v-else-if="domControl.ajaxApi.getApkPayMethodsAction.showLoading==true">
                            {{$t("deposit.step.hint.loading")}}
                        </div>
                        <br>
                    </div>


                    <!-- 4.確認付款 -->
                    <div class="cm-depositcenter-deposit2022-step-title">{{$t("deposit.step.depositConfirm")}}</div>
                    <!-- 電子發票 -->
                    <div v-if="userDepositData.cashflowSupplier.invoiceRequired == 1">
                        <div class="cm-depositcenter-deposit2022-invoice-prompt">
                            {{$t('deposit.invoice.prompt')}}
                        </div>
                        <br>
                        
                        <div class="cm-depositcenter-deposit2022-invoice-frame">
                            <div class="row">
                                <!-- 電子發票(個人)checkbox -->
                                <div class="col-4 d-flex align-items-center">
                                    <div>
                                        <input
                                            class="cm-depositcenter-deposit2022-invoice-checkbox" type="checkbox" 
                                            :id="invoice.personalInvoice.value"
                                            :value="invoice.personalInvoice.value"
                                            @change="domSelectInvoiceType"
                                            v-model="programData.invoice.invoiceCheckValue">
                                    </div>
                                    <label :for="invoice.personalInvoice.value">
                                        {{$t('deposit.invoice.PersonalInvoice')}}
                                    </label>
                                </div>
                                <!-- 電子發票(統編)checkbox -->
                                <div class="col-4 d-flex align-items-center">
                                    <div>
                                        <input
                                            class="cm-depositcenter-deposit2022-invoice-checkbox" type="checkbox" 
                                            :id="invoice.GUINumberInvoice.value"
                                            :value="invoice.GUINumberInvoice.value"
                                            @change="domSelectInvoiceType"
                                            v-model="programData.invoice.invoiceCheckValue">
                                    </div>
                                    <label :for="invoice.GUINumberInvoice.value">
                                        {{$t('deposit.invoice.GUINumberInvoice')}}
                                    </label>
                                </div>
                                <!-- 發票捐贈(伊甸、家扶、創世...等等)checkbox -->
                                <div class="col-4 d-flex align-items-center">
                                    <div>
                                        <input
                                            class="cm-depositcenter-deposit2022-invoice-checkbox" type="checkbox" 
                                            :id="invoice.donationInvoice.value" 
                                            :value="invoice.donationInvoice.value"
                                            @change="domSelectInvoiceType"
                                            v-model="programData.invoice.invoiceCheckValue">
                                    </div>
                                    <label :for="invoice.donationInvoice.value">
                                        {{$t('deposit.invoice.DonationInvoice')}}
                                    </label>
                                </div>
                            </div>
                            <br />

                            <!-- 電子發票(個人)-->
                            <div v-show="programData.invoice.selectInvoiceValue==invoice.personalInvoice.value" style="display:none">
                                <div class="row">
                                    <div class="col-12 col-md-8 col-lg-6">
                                        <select class="form-control form-control-lg cm-depositcenter-deposit2022-select"
                                                v-model="programData.invoice.personalInvoice.selectCarrierValue"
                                        >
                                            <option :value="invoice.personalInvoice.carriers.CMCarrier.value">{{$t('deposit.invoice.CMCarriers')}}</option>
                                            <option :value="invoice.personalInvoice.carriers.phoneCarrier.value">{{$t('deposit.invoice.PhoneCarriers')}}</option>
                                            <option :value="invoice.personalInvoice.carriers.certificateCarrier.value">{{$t('deposit.invoice.CertificateCarriers')}}</option>
                                        </select>
                                    </div>
                                </div>
                                <br />
                                <!-- 台遊會員載具 -->
                                <div class="row" v-show="programData.invoice.personalInvoice.selectCarrierValue==invoice.personalInvoice.carriers.CMCarrier.value">
                                    <div class="col-12 col-sm-10 col-md-8 row d-flex form-group">
                                        <div class="col-12 col-md-4 text-nowrap">
                                            {{$t('deposit.invoice.MobilePhone')}}
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <input class="form-control"
                                                :readonly="programData.invoice.personalInvoice.carriers.CMCarrier.invoicePhoneReadonly==true"
                                                v-model="programData.invoice.personalInvoice.carriers.CMCarrier.inputInvoicePhone">
                                        </div>
                                    </div>
                                    <div class="px-4 px-md-3 col-md-4 row d-flex form-group" style="font-size:15px" v-if="invoice.personalInvoice.carriers.CMCarrier.inputInvoicePhone!=''">
                                        {{$t('deposit.invoice.bringAuto.prompt')}}
                                    </div>
                                </div>
                                <!-- 手機條碼載具 -->
                                <div class="row" v-show="programData.invoice.personalInvoice.selectCarrierValue==invoice.personalInvoice.carriers.phoneCarrier.value">
                                    <div class="col-12 col-sm-10 col-md-8 row d-flex form-group">
                                        <div class="col-12 col-md-4 text-nowrap">
                                            {{$t('deposit.invoice.MobileCarriers')}}
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <input class="form-control"
                                                :readonly="programData.invoice.personalInvoice.carriers.phoneCarrier.phoneBarcodeReadonly==true"
                                                v-model="programData.invoice.personalInvoice.carriers.phoneCarrier.inputPhoneBarcode">
                                        </div>
                                    </div>
                                    <div class="px-4 px-md-3 col-md-4 row d-flex form-group" style="font-size:15px" v-if="invoice.personalInvoice.carriers.phoneCarrier.inputPhoneBarcode!=''">
                                        {{$t('deposit.invoice.bringAuto.prompt')}}
                                    </div>
                                </div>
                                <!-- 自然人憑證載具 -->
                                <div class="row" v-show="programData.invoice.personalInvoice.selectCarrierValue==invoice.personalInvoice.carriers.certificateCarrier.value">
                                    <div class="col-12 col-sm-10 col-md-8 row d-flex form-group">
                                        <div class="col-12 col-md-4 text-nowrap">
                                            {{$t('deposit.invoice.CDCCarriers')}}
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <input class="form-control"
                                                :readonly="programData.invoice.personalInvoice.carriers.certificateCarrier.certificateReadonly==true"
                                                v-model="programData.invoice.personalInvoice.carriers.certificateCarrier.inputCertificate" >
                                        </div>
                                    </div>
                                    <div class="px-4 px-md-3 col-md-4 row d-flex form-group" style="font-size:15px" v-if="invoice.personalInvoice.carriers.certificateCarrier.inputCertificate!=''">
                                        {{$t('deposit.invoice.bringAuto.prompt')}}
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-8 text-nowrap cm-depositcenter-deposit2022-remind-color">
                                        {{$t('deposit.invoice.Remind')}}
                                    </div>
                                </div>
                            </div>

                            <!-- 電子發票(統編) -->
                            <div v-show="programData.invoice.selectInvoiceValue==invoice.GUINumberInvoice.value" style="display:none">
                                <div class="row">
                                    <div class="col-12 col-sm-10 col-md-8 row d-flex form-group">
                                        <div class="col-12 col-md-4 text-nowrap">
                                            {{$t('deposit.invoice.Email')}}
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <input class="form-control" type="text" v-model="programData.invoice.GUINumberInvoice.inputEmail">
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-8 row d-flex pt-2">
                                        <div class="col-12 col-md-4 text-nowrap">
                                            {{$t('deposit.invoice.GUI')}}
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <input class="form-control" type="text" v-model="programData.invoice.GUINumberInvoice.inputGUINumber">
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-8 text-nowrap cm-depositcenter-deposit2022-remind-color">
                                        {{$t('deposit.invoice.PlzChooseInvoice')}}
                                    </div>
                                </div>
                            </div>

                            <!-- 發票捐贈(伊甸、家扶、創世...等等) -->
                            <div v-show="programData.invoice.selectInvoiceValue==invoice.donationInvoice.value" style="display:none">
                                <div class="row">
                                    <div class="col-12 col-md-8 col-lg-6 form-group">
                                        <select v-model="programData.invoice.donationInvoice.selectLoveCode" class="form-control form-control-lg cm-depositcenter-deposit2022-select">  
                                            <option v-for="(loveCodObj, index) in programData.invoice.donationInvoice.loveCodeJson" :key="index"
                                                    :value="loveCodObj.loveCode">
                                                {{loveCodObj.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <br />
                                <div class="row"
                                    v-show="programData.invoice.donationInvoice.selectLoveCode=='Other'">
                                    <div class="col-12 col-sm-10 col-md-8 row d-flex">
                                        <div class="col-12 col-xl-4 text-nowrap">
                                            {{$t('deposit.invoice.LoveCode.KeyinOther')}}
                                        </div>
                                        <div class="col-12 col-xl-6">
                                            <input class="form-control" type="text" v-model="programData.invoice.donationInvoice.inputOtherLoveCode">
                                        </div>
                                    </div>
                                    <div class="col-12 cm-depositcenter-deposit2022-remind-color">
                                        <br /><span>{{$t('deposit.invoice.LoveCode.KeyinRemind')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>

                    <!-- 儲值按鈕 -->
                    <div class="loginBtnBox d-flex justify-content-center">
                        <a href="#"
                           class="cm-depositcenter-deposit2022-receipt-btn"
                           @click.prevent="clickIWantBtn"
                           v-if="!domControl.btn.iWantDeposit.showLoading"
                        >
                            {{$t('deposit.IWant')}}
                        </a>
                        
                        <div v-else class="spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </form>
        </section>
        <div style="display:none">
            <!-- [B] 建儲值單後金流導向 -->
            <form id="form_depositPost">
                <input id="depositPostCookie" type="hidden" name="depositPostCookie" value="" />
                <input id="depositPostMemberPk" type="hidden" name="depositPostKey" value="" />
                <input id="depositPostPk" type="hidden" name="depositId" value="" />
                <input id="newCM" type="hidden" name="newCM" value="true" />
            </form>
            <!-- [E] 建儲值單後金流導向 -->
        </div>
        <!-- ------------------------------儲值結束------------------------------ -->
    </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import * as DepositAdapter from "@/assets/js/deposit/Deposit.js";
import CookieUtil from "@/assets/js/util/CookieUtil.js";
import InvoiceUtil from "@/assets/js/util/InvoiceUtil.js";
import store from '@/store/store-controller/store.js';
import router from '@/router.js';
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js';
import TimeUtil from '@/assets/js/util/TimeUtil.js'
import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'


var asyncTry;


export default {
    name: "deposit",
    created() {
        if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false) {
            this.pageInsertScript();
        }
    },
    mounted() {
        console.log('vue週期 - mounted');
        this.updateTopBackgroundImg();
        this.ajaxGetInvoiceMemberCarrier();
        
        // 更換語言時
        const self = this;
        if(eventBus["_events"][process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DEPOSIT] !== undefined) {
            delete eventBus["_events"][process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DEPOSIT]
        }

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);

        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DEPOSIT, function(i18n) {
            self.updateTopBackgroundImg(i18n);
            self.programData.invoice.donationInvoice.loveCodeJson = InvoiceUtil.getLoveCodeJsonByLanguage(i18n.locale);
            
            // url有gameCode參數
            if(self.$route.query.gameCode !== undefined) {
                self.autoSelectFromUrl.isAutoSelect = true
                self.autoSelectFromUrl.gameCode = self.$route.query.gameCode
            }
            self.pageSetInitData();
        })

        // 驗證登入所需參數，未登入狀態則顯示loginModal讓玩家登入，玩家登入完畢後再回來
        let verifySetting = {
            verifyStatus: true, // 驗證登入
            from: router.currentRoute.name, // 來源頁面
            setFrontendRouterPushCookie: true, // 是否設置cookie方便登入會導回from設置的頁面
            showLoginModal: true, // 未登入狀態下顯示loginModal
            setCookie: {}
        };

        // 判斷參數
        if(this.$route.query.result != undefined) { // 依照result參數處理訂單的成功失敗
            var showMsgModalText = '';
            if(this.$route.query.result == 'success') { // 成功單
            
                if(this.$route.query.paymentPlatform!=undefined && this.$route.query.paymentPlatform=="NEWDTATM") { // 藍新虛擬ATM
                    showMsgModalText = this.$i18n.t('deposit.DepositSucces.NEWDTATM')
                        .replace("{bankCode}", this.$route.query.bankCode)
                        .replace("{codeNo}", this.$route.query.codeNo)
                        .replace("{money}", this.$route.query.money)
                        .replace("{id}", this.$route.query.id)
                }
                else {
                    showMsgModalText = this.$i18n.t('deposit.DepositSucces') + '：<br>【' 
                    + this.$i18n.t('deposit.DepositCMID') + this.$route.query.id + '；'
                    + this.$i18n.t('deposit.DepositMoney') + this.$route.query.money + " " + this.$route.query.currency + '】';
                }
                
                // 判斷是否有iFrame_deposit_callback cookie，如有則更改cookie值
                if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_IFRAME_DEPOSIT_CALLBACK)!==false) {
                    let cookie = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_IFRAME_DEPOSIT_CALLBACK);
                    cookie = cookie.replace(/^no/, this.$route.query.id);
                    cookie = cookie.replace(/false$/, "true");
                    CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_IFRAME_DEPOSIT_CALLBACK, cookie);
                }
            }
            else { // 失敗單
                showMsgModalText = this.$i18n.t('deposit.DepositFail') + '：<br>【' + this.$route.query.msg +'】';
            }
            this.setModalText(showMsgModalText,'');
        }
        else if(this.$route.query.gameCode !== undefined // 判斷url或cookie是否有gameCode參數
            || CookieUtil.getCookie(process.env.VUE_APP_COOKIE_DEPOSIT_AUTOSELECT_GAMECODE)!==false) {
            if(this.$route.query.gameCode !== undefined) { // url有gameCode參數
                this.autoSelectFromUrl.isAutoSelect = true
                this.autoSelectFromUrl.gameCode = this.$route.query.gameCode
                verifySetting.setCookie[process.env.VUE_APP_COOKIE_DEPOSIT_AUTOSELECT_GAMECODE] = this.$route.query.gameCode
            }
            else if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_DEPOSIT_AUTOSELECT_GAMECODE)!==false) {  // cookie有gameCode參數
                this.autoSelectFromUrl.isAutoSelect = true
                this.autoSelectFromUrl.gameCode = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_DEPOSIT_AUTOSELECT_GAMECODE)
                CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_DEPOSIT_AUTOSELECT_GAMECODE);
            }
        }

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_VERIFY_LOGIN, verifySetting); // 驗證是否為登入狀態
    },
    data() {
        return {
            constants: {
                cashflow: {
                    cashflowRow: "cashflowRow",
                    cashflowSupplierCategory: "cashflowSupplierCategory",
                    cashflowSuppliers: "cashflowSuppliers",
                    cashflowSupplier: "cashflowSupplier",
                    vendors: "vendors",
                    vendor: "vendor",
                    price: {
                        notApplicable: "notApplicable",
                        pleaseSelect: "pleaseSelect",
                        pleaseSelectDepositItemName: "pleaseSelectDepositItemName",
                        showTWDAmount: "showTWDAmount",
                        showUSDAmount: "showUSDAmount",
                    },
                },
                logo: {
                    payLogoArr: ["alipay", "creditcard", "default", "esunbank", "gashplus", "jkopay", "mol", "mycard", "mycardpay", "mycardpoint", "newebpay", "paypal", "pepay", "test", "台灣之星", "台灣大哥大", "中華電信市話", "中華電信HINET", "中華電信手機", "遠傳電信", "亞太電信", "八達通", "繳費靈"],
                    payLogoJustifyContentCenterArr: ["creditcard", "pepay"]
                },
                css: {
                    color: {
                        selected: "#FFD31C",
                        canNotSelect: "#939393"
                    },
                    borderColor: {
                        selected: "#FFD31C",
                        canNotSelect: "#939393"
                    }
                },
                codapay: {
                    pushPageArrByGameCode: ["jj"]
                }
            },
            ajaxMutex: {
                getApkPayMethodsActionKey: "",
                getApkDepositPidsActionKey: ""
            },
            invoice: {
                personalInvoice: { // 電子發票(個人)
                    value: "PersonalInvoice",
                    invoiceType: "2",
                    carriers: {
                        phoneCarrier: { // 手機條碼載具
                            value: "phoneCarrier",
                            carrierType: "3J0002",
                        },
                        certificateCarrier: { // 自然人憑證載具
                            value: "certificateCarrier",
                            carrierType: "CQ0001",
                        },
                        CMCarrier: { // 台遊會員載具
                            value: "CMCarrier",
                            carrierType: "EG0379",
                        }
                    },
                },
                GUINumberInvoice: { // 電子發票(統編)
                    value: "GUINumberInvoice",
                    invoiceType: "3",
                },
                donationInvoice: { // 發票捐贈(伊甸、家扶、創世...等等)
                    value: "DonationInvoice",
                    invoiceType: "1",
                }
            },
            domControl: {
                showDepositArea: true, // 顯示選擇區域，依照區域判斷是否進行正常儲值 or 使用Codapay儲值
                showNormalDeposit: false, // true:正常付費流程(台港澳)

                btn: {
                    topupType: { // 儲值類型
                        wantShowBtnArr: [], // 欲顯示在畫面上的儲值類型按鈕
                        selectedTopupType: "",
                        isShowTopupTypeBtn: false, 
                    },
                    iWantDeposit: { // 我要儲值按鈕
                        showLoading: false
                    }
                },
                ajaxApi: {
                    getApkPayMethodsAction: {
                        showLoading: false
                    },
                    getApkDepositPidsAction: {
                        showLoading: false
                    },
                }
            },
            domPrompt: {
                depositItemInfoPurchasePeriod: ""
            },
            depositTypeSetting: { // 儲值種類設定
                typeObj: {
                    Currency: { // 一般儲值
                        order: 1, // 順序
                        codeName: "Currency", // API儲值類型的劃分名稱
                        name: this.$i18n.t('deposit.topupType.Currency'), // 顯示於畫面之文字
                    },
                    Bundle: { // 禮包儲值
                        order: 2,
                        codeName: "Bundle",
                        name: this.$i18n.t('deposit.topupType.Bundle'),
                    },
                },
                default: "Currency", // 預設顯示
            },
            remoteDepositInfoResult: { // API取得資訊
                gameInfoJson: {},
                userInfo: {
                    pk: "",
                    fk: "",
                    accountCreated: "",
                    mmiInfoJson: {},
                },
                localeIdJson: {}, // 遊戲有開放哪個區域
                allowGameCodeByLanguage: {}, // 每個語系底下允許的gameCode
            },
            getApkDepositPidsActionResult: { // API取得資訊
                currencyDepositItemInfoArr: [],
                bundleDepositItemInfoArr: []
            },
            getApkPayMethodsActionResult: { // API取得資訊
                cashflowSupplierCategoryArr: [], // 金流群組
                payMethodArr: [] // 付款方式&金流商
            },
            programData: { // 程式使用到的數據，數據會隨著程式流程、玩家點選畫面而有所更動
                gameInfoJson: {},
                serverGroupInfoJson: {},
                serverInfoJson: {},
                roleInfoJson: {},
                depositTypeArr: [],
                depositAdapter: null,
                depositItemInfoArr: [], // 儲值品項資訊
                cashflowSupplierCategoryJson: {}, // 金流群組
                cashflowSupplierJson: {}, // 金流商
                countryList: [], // 與金流商的cashflowSupplierLocale作對應，index = cashflowSupplierLocale-1
                invoice: { // 電子發票
                    requiredCashflowSupplierNum: [], // 需要開發票的金流商num
                    selectInvoiceValue: "DonationInvoice",
                    invoiceCheckValue: ["DonationInvoice"], // 用於實現<input type="checkbox">單選
                    personalInvoice: {
                        selectCarrierValue: "CMCarrier", // 畫面上選擇的載具
                        carriers: {
                            phoneCarrier: { // 手機條碼載具
                                inputPhoneBarcode: "",
                                phoneBarcodeReadonly: false // 控制輸入欄位是否為readonly
                            },
                            certificateCarrier: { // 自然人憑證載具
                                inputCertificate: "",
                                certificateReadonly: false // 控制輸入欄位是否為readonly
                            },
                            CMCarrier: { // 台遊會員載具
                                inputInvoicePhone: "", // 收件人電話
                                invoicePhoneReadonly: false // 控制輸入欄位是否為readonly
                            }
                        },
                    },
                    GUINumberInvoice: { // 電子發票(統編)
                        inputEmail: "",
                        inputGUINumber: "",
                    },
                    donationInvoice: { // 發票捐贈(伊甸、家扶、創世...等等)
                        selectLoveCode: InvoiceUtil.getFirstLoveCode(), // 畫面上選擇的捐贈單位
                        inputOtherLoveCode: "",
                        loveCodeJson: InvoiceUtil.getLoveCodeJsonByLanguage(this.$i18n.locale), // 要渲染至畫面的愛心碼
                    }
                }
            },
            userDepositData: {
                // 遊戲相關
                gameCode:  "",
                serverGroupId: "",
                gameServerNum: "",
                gameServerName: "",
                gameRoleId: "",
                gameRoleName: "",
                gameRoleObj: "",
                // 儲值品項相關
                depositType: "", // 玩家畫面上選擇的儲值類型，預設空字串，有資料為字串
                depositItemInfoArr: "",
                totalTwdAmount: 0,
                totalUsdAmount: 0,
                // 金流相關
                integrateCashflowSupplierJson: "", // 記錄的每組金流商都可以支付depositItemInfoArr中所有儲值品項資訊(儲值品項資訊底下會有許多儲值品項，每個資訊底下會有一組品項符合該金流商)
                cashflowSupplierCategory: "", // 玩家畫面上選取的金流群組，預設空字串，有資料為Object
                cashflowSupplier: "", // 玩家儲值時選擇要使用的金流商，預設空字串，有資料為Object
                vendor: "", // 玩家儲值時選擇要使用的電信商，預設空字串，有資料string
            },
            rawData: { // 原始數據，將數據存於變數中，不會再更動
                areaJsonList: [],
            },
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
            autoSelectFromCookie: { // 當有特定cookie存在時，將資訊儲存於此，最終用於判斷是否幫玩家帶入儲值資訊
                isAutoSelect: false,       // 用於判斷是否自動帶入儲值資訊
                cookieGamecode: null,      // cookie取得，遊戲id
                cookieSid: null,           // cookie取得，伺服器id
                cookiePid: null,           // cookie取得，品項id
                cookieRid: null,           // cookie取得，角色id 
                cookieRname: null,         // cookie取得，角色名稱
                gameServerGroupName: null, // 伺服器分區名稱
                gameServerGroup: null,     // 伺服器分區code
                gameServerNum: null,          // DB GAME_SERVER資料表的GAME_SERVER_LIST_IDX欄位
                selectGameCodeComplete: false,
                selectGameServerGroupComplete: false,
                selectGameServerComplete: false,
                selectRoleIdComplete: false,
                selectDepositItemComplete: false,
            },
            autoSelectFromUrl: {
                isAutoSelect: false,
                gameCode: null,
            },
        }
    },
    methods: {

        // 為了繞過CORS問題，用script方式取得玩家基本資料
        async pageInsertScript() {
            let url = process.env.VUE_APP_URL_DOMAIN_LOGIN + "/initMdepositJsonAction.shtml?paymentStatus=3"
            if(document.querySelectorAll(`head script[src='${url}']`).length <= 0) {
                let redirectDepositPage = document.createElement("script");
                redirectDepositPage.setAttribute("src", url);
                document.head.appendChild(redirectDepositPage);
            }
            await this.pageCheckInitData();
        },



        // 確認是否有從後端取得玩家基本資料
        pageCheckInitData() {
            let self = this;
            let count = 0;
            let waitSecond = 1000;
            let limitN = process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND / waitSecond;
            asyncTry = setInterval(function() {
                try {
                    if(remoteDepositInfo) {
                        self.pageSetInitData();
                    }
                }
                catch(e) {}
                if(count >= limitN ) {
                    clearInterval(asyncTry);
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    return;
                }
                count ++;
            }, waitSecond);
        },



        // 對後端取得的玩家基本資料進行初始化
        async pageSetInitData() {
            try{
                clearInterval(asyncTry);
                // 遊戲相關資訊
                this.remoteDepositInfoResult.gameInfoJson = JSON.parse(remoteDepositInfo.getDeposit());
                this.remoteDepositInfoResult.allowGameCodeByLanguage = JSON.parse(remoteDepositInfo.getLanguageCode());

                // 玩家資訊
                this.remoteDepositInfoResult.userInfo.fk = JSON.parse(remoteDepositInfo.getFk());
                this.remoteDepositInfoResult.userInfo.pk = JSON.parse(remoteDepositInfo.getPk());
                this.remoteDepositInfoResult.userInfo.accountCreated = remoteDepositInfo.getAccountCreated();
                this.remoteDepositInfoResult.userInfo.mmiInfoJson = remoteDepositInfo.getMmiInfoJson()

                // 遊戲有開放哪個區域
                this.remoteDepositInfoResult.localeIdJson = JSON.parse(remoteDepositInfo.getLocaleJson());

                if(Object.keys(this.remoteDepositInfoResult.gameInfoJson).length == 0) {
                    alert(this.$i18n.t('deposit.error.NeverLoggedGames'));
                    router.push({name: process.env.VUE_APP_ROUTER_HOME});
                }
                else {
                    // 檢查到指定的cookie，執行自動帶入儲值資訊
                    if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_IFRAME_DEPOSIT) !== false) {
                        let iFrameDepositString = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_IFRAME_DEPOSIT);
                        CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_IFRAME_DEPOSIT);
                        await this.dealWithCookie_iframeDeposit(iFrameDepositString); // 處理cookie所帶的資訊
                        if(this.autoSelectFromCookie.isAutoSelect) {
                            let cookieValue = "no_" + this.autoSelectFromCookie.cookiePid + "_false";
                            CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_IFRAME_DEPOSIT_CALLBACK, cookieValue);
                        }
                    }
                    else if(this.autoSelectFromUrl.isAutoSelect == true) {
                        this.clickDepositNormal()
                    }
                    
                    // 清除變數值
                    this.clearGameDataByStepNum(100)
                    this.clearDepositDataByStepNum(100)

                    // 初始化資料
                    this.pageGetCountryList();

                    // 初始化遊戲資訊
                    this.initGameInfo();
                }
            }
            catch(err) {
                console.log(err);
                alert(this.$i18n.t('common.PleaseLogin'));
                router.push({name: process.env.VUE_APP_ROUTER_HOME});
            }
        },



        // 取得地區list
        pageGetCountryList() {
            // 從檔案取得資料
            if(this.rawData.areaJsonList.length == 0) {
                this.rawData.areaJsonList = require.context('../assets/depositArea', false, /[A-Za-z0-9-_,\s]+\.json$/i);
            }
            
            // 判斷目前語系
            let counrty_switch = 'country_TW';
            switch(store.getters['storeI18n/getNowLanguage']) {
                case 'zh-TW':
                    counrty_switch = 'country_TW';
                    break;
                case 'zh-CN':
                    counrty_switch = 'country_CN';
            }
            
            // 用目前語系取得對應的地區list
            let self = this;
            this.rawData.areaJsonList.keys().forEach(key => {
                let areaJson = this.rawData.areaJsonList(key);
                self.programData.countryList = areaJson[counrty_switch].split(',');
            });
        },



        // 初始化金流資訊
        initCashflowSupplierData() {
            let cashflowSupplierCategoryJson = {}

            // 依照cashflowSupplierCategoryArr建立金流群組至cashflowSupplierCategoryJson
            for(let i=0; i<this.getApkPayMethodsActionResult.cashflowSupplierCategoryArr.length; i++) {
                let cashflowSupplierCategoryObjFromApi = this.getApkPayMethodsActionResult.cashflowSupplierCategoryArr[i];

                // cashflowSupplierNumArr內的元素為金流商num，將所有num進行串接，之後用於判斷
                // ex: 如串接起來後為_123_456_，之後如果有金流商num為123，則判斷_123_是否為_123_456_的子字串，就代表該金流商是否為此群組
                let cashflowSupplierJsonKey = this.genCashflowSupplierCategoryJsonKeyByCashflowSupplierNumArr(cashflowSupplierCategoryObjFromApi["cashflowSupplierNumArr"])

                // 產生金流群組相關資訊放入cashflowSupplierCategoryJson
                let newCashflowSupplierCategoryObj = this.genCashflowSupplierCategoryObj()
                newCashflowSupplierCategoryObj["cashflowSupplierCategoryName"] = cashflowSupplierCategoryObjFromApi["cashflowSupplierCategoryName"]
                newCashflowSupplierCategoryObj["cashflowSupplierNumArr"] = cashflowSupplierCategoryObjFromApi["cashflowSupplierNumArr"]
                newCashflowSupplierCategoryObj["subOption"] = cashflowSupplierCategoryObjFromApi["subOption"]
                newCashflowSupplierCategoryObj["domDisplayName"] = cashflowSupplierCategoryObjFromApi["cashflowSupplierCategoryName"]
                newCashflowSupplierCategoryObj["logo"] = cashflowSupplierCategoryObjFromApi["logo"]
                cashflowSupplierCategoryJson[cashflowSupplierJsonKey] = newCashflowSupplierCategoryObj
            }

            // 取得cashflowSupplierCategoryJson所有的key
            let cashflowSupplierCategoryJsonKeyArr = Object.keys(cashflowSupplierCategoryJson)

            // 逐一處理金流商
            for (let i = 0; i < this.getApkPayMethodsActionResult.payMethodArr.length; i++) { // 逐一取出payMethod
                // payMethod
                let payMethodObj = this.getApkPayMethodsActionResult.payMethodArr[i]

                // 取出payMethod下所有金流商
                let cashflowSupplierArr = payMethodObj.cashflowSuppliers
                
                // 將每個金流商分類至金流群組中
                for (let j = 0; j < cashflowSupplierArr.length; j++) {
                    // 金流商
                    let cashflowSupplier = cashflowSupplierArr[j]

                    // 重組資料 - 電信商vendor(在API傳來的金流商中，若沒有電信商，則不會有vendors屬性)
                    let vendorJson = {}
                    if(cashflowSupplier.vendors!=undefined
                        && cashflowSupplier.vendors!=null
                        && Array.isArray(cashflowSupplier.vendors)) { // 若沒有電信商，API不傳vendors屬性
                        for(let k=0; k<cashflowSupplier.vendors.length; k++) {
                            let vendorName = cashflowSupplier.vendors[k]
                            let newVendorObj = this.genVendorObj()
                            newVendorObj["vendorName"] = vendorName
                            vendorJson[vendorName] = newVendorObj
                        }
                    }
                    this.$set(cashflowSupplier, "vendorJson", vendorJson)
                    
                    // 重組資料 - 付款方式payMethod
                    cashflowSupplier["payMethod"] = payMethodObj["payMethod"]
                    cashflowSupplier["payMethodName"] = payMethodObj["payMethodName"]

                    // 重組資料 - 增加畫面控制屬性
                    this.$set(cashflowSupplier, "domCanSelect", false) // 玩家是否選取
                    this.$set(cashflowSupplier, "domIsSelect", false) // 玩家是否選取

                    // 重組資料 - 要顯示於頁面上的名稱
                    //cashflowSupplier["domDisplayName"] = this.getDomDisplayName(cashflowSupplier.cashflowSupplierName, cashflowSupplier.num)
                    cashflowSupplier["domDisplayName"] = cashflowSupplier["displayName"]

                    // 重組資料 - 顯示於畫面上的順序
                    cashflowSupplier["domSortOrder"] = cashflowSupplier["sortOrder"]
                    delete cashflowSupplier["sortOrder"]

                    // 金流商若需要開發票，將金流商num寫入this.programData.invoice.requiredCashflowSupplierNum
                    if(cashflowSupplier["invoiceRequired"] == 1) {
                        this.programData.invoice.requiredCashflowSupplierNum.push(cashflowSupplier["num"])
                    }

                    // 若金流商有被歸類至群組，則cashflowSupplierCategoryJsonKey不會為空
                    let cashflowSupplierCategoryJsonKey = ""
                    let subCashflowSupplierCategoryJsonKey = this.genCashflowSupplierCategoryJsonKeyByCashflowSupplierNum(cashflowSupplier["num"])
                    for(let i=0; i<cashflowSupplierCategoryJsonKeyArr.length; i++) {
                        let tmpCashflowSupplierCategoryJsonKey = cashflowSupplierCategoryJsonKeyArr[i]
                        if(tmpCashflowSupplierCategoryJsonKey.indexOf(subCashflowSupplierCategoryJsonKey) != -1) {
                            cashflowSupplierCategoryJsonKey = tmpCashflowSupplierCategoryJsonKey
                            break
                        }
                    }

                    // 根據cashflowSupplierCategoryJsonKey是否為空，判斷金流商是否有群組，有群組則將金流商歸至群組下，沒有則自建群組
                    if(cashflowSupplierCategoryJsonKey == "") { // 金流商沒有金流群組，故自建金流群組
                        cashflowSupplierCategoryJsonKey = this.genCashflowSupplierCategoryJsonKeyByCashflowSupplierNum(cashflowSupplier["num"])
                        let newCashflowSupplierCategoryObj = this.genCashflowSupplierCategoryObj()
                        newCashflowSupplierCategoryObj["domDisplayName"] = cashflowSupplier["domDisplayName"]
                        newCashflowSupplierCategoryObj["domSortOrder"] = cashflowSupplier["domSortOrder"]
                        newCashflowSupplierCategoryObj["logo"] = cashflowSupplier["logo"]
                        newCashflowSupplierCategoryObj["cashflowSupplierNumArr"].push(cashflowSupplier["num"])
                        cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey] = newCashflowSupplierCategoryObj

                        this.programData.cashflowSupplierJson[cashflowSupplier["num"]] = cashflowSupplier
                    }
                    else { // 金流商有金流群組，加入該群組
                        // 判斷排序編號
                        if(cashflowSupplier["domSortOrder"] < cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey]["domSortOrder"]) {
                            cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey]["domSortOrder"] = cashflowSupplier["domSortOrder"]
                        }
                        // 金流商名稱
                        if(cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey]["subOption"] == "cashflowSupplierLocale") {
                            cashflowSupplier["domDisplayName"] = this.programData.countryList[cashflowSupplier["cashflowSupplierLocale"]-1]
                        }
                        else if(cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey]["subOption"] == "displayName") {
                            cashflowSupplier["domDisplayName"] = cashflowSupplier["displayName"]
                        }
                        // 金流商資訊加入金流群組
                        this.programData.cashflowSupplierJson[cashflowSupplier["num"]] = cashflowSupplier
                    }
                }
            }

            /**
             * 將金流群組依照domSortOrder進行排序，爾後透過Object.keys(this.programData.cashflowSupplierCategoryJson)取得的陣列，其內元素(金流群組key)就會是排序過的
             */
            let cashflowSupplierCategoryOrderArr = []
            // 每個金流群組組出object
            for(let i=0; i<Object.keys(cashflowSupplierCategoryJson).length; i++) {
                let cashflowSupplierCategoryJsonKey = Object.keys(cashflowSupplierCategoryJson)[i]
                cashflowSupplierCategoryOrderArr.push({
                    "cashflowSupplierCategorySortOrder": cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey].domSortOrder,
                    "cashflowSupplierCategoryJsonKey": cashflowSupplierCategoryJsonKey
                })
            }
            // 對陣列中的object進行排序
            cashflowSupplierCategoryOrderArr.sort((jsonObj1, jsonObj2) => {
                return jsonObj1["cashflowSupplierCategorySortOrder"] - jsonObj2["cashflowSupplierCategorySortOrder"]
            })
            // 依照cashflowSupplierCategoryOrderArr元素順序，將整理後的cashflowSupplierCategoryObj資料放入this.programData.cashflowSupplierCategoryJson
            for(let i=0; i<cashflowSupplierCategoryOrderArr.length; i++) {
                let cashflowSupplierCategoryJsonKey = cashflowSupplierCategoryOrderArr[i]["cashflowSupplierCategoryJsonKey"]
                this.$set(this.programData.cashflowSupplierCategoryJson, cashflowSupplierCategoryJsonKey, cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey])
            }
        },
        
        
        
        // 初始化儲值商品資訊
        initDepositItemInfoJson() {
            // 儲值品項資訊陣列
            let depositItemInfoArr = []

            // 依照儲值類型，從對應的變數取得儲值品項資訊
            let depositDataAttrName = `${this.userDepositData.depositType.toLowerCase()}DepositItemInfoArr`
            if(this.getApkDepositPidsActionResult[depositDataAttrName] != undefined) {
                depositItemInfoArr = this.getApkDepositPidsActionResult[depositDataAttrName]
            }

            for(let i=0; i<depositItemInfoArr.length; i++) {
                // 取得儲值品項資訊
                let depositItemInfoObj = JSON.parse(JSON.stringify(depositItemInfoArr[i]))

                // 儲值品項資訊增加畫面控制屬性
                this.$set(depositItemInfoObj, "domCanSelect", true);
                this.$set(depositItemInfoObj, "domIsSelect", false);

                // 儲值品項資訊在畫面上的排序
                depositItemInfoObj["domSortOrder"] = depositItemInfoObj["itemOrder"]
                delete depositItemInfoObj["itemOrder"]

                // 若儲值品項資訊沒有endTime屬性，則加入，且其值為-1(無購買期限)
                if(depositItemInfoObj["endTime"] == undefined) {
                    depositItemInfoObj["endTime"] = -1
                }
                
                // 對儲值品項資訊中的每一個儲值品項做處理
                let newItemArr = []
                for(let j=0; j<depositItemInfoObj.itemArr.length; j++) {
                    // 取得儲值品項
                    let depositItemObj = depositItemInfoObj.itemArr[j]

                    // 儲值品項的VENDOR若為"USD"則轉為空字串
                    depositItemObj["currency"] = "TWD"
                    if(depositItemObj["VENDOR"] == "USD") {
                        depositItemObj["VENDOR"] = ""
                        depositItemObj["currency"] = "USD"
                    }

                    // 判斷若有金流可支付，則儲值品項加入newItemArr
                    if(null != this.findCashflowSupplierCategoryJsonKeyByCashflowSupplierNum(depositItemObj["FK_CASHFLOW_SUPPLIER"])) {
                        newItemArr.push(depositItemObj)
                    }
                }

                // 有金流可支付的儲值品項
                if(newItemArr.length > 0) {
                    depositItemInfoObj["itemArr"] = newItemArr
                    this.programData.depositItemInfoArr.push(depositItemInfoObj)
                }
            }

            // 對儲值品項資訊做排序
            this.programData.depositItemInfoArr.sort((jsonObj1, jsonObj2) => {
                return jsonObj1["domSortOrder"] - jsonObj2["domSortOrder"]
            })

            // 自動帶入儲值品項資訊
            if(this.autoSelectFromCookie.isAutoSelect==true) {  
                for(let i=0; i<this.programData.depositItemInfoArr.length; i++) {
                    let depositItemInfoObj = this.programData.depositItemInfoArr[i]
                    if(this.autoSelectFromCookie.cookiePid == depositItemInfoObj["referenceName"]) {
                        this.domSelectDepositItemName(depositItemInfoObj)
                    }
                }
            }
        },
        
        

        // 初始化遊戲資訊
        initGameInfo() {
            this.clearGameDataByStepNum(40);
            
            // API回傳每個語系底下所對應之gameCode，依照當前頁面語系去取，最後顯示這些遊戲
            let gameCodeFilter = [] // 要顯示於頁面的遊戲之gameCode
            const userLanguage = this.$i18n.locale.split("-")[0]
            if(this.remoteDepositInfoResult.allowGameCodeByLanguage[userLanguage]!=undefined) {
                gameCodeFilter = this.remoteDepositInfoResult.allowGameCodeByLanguage[userLanguage]
            }
            
            // 依照gameCode進行過濾
            if(gameCodeFilter.length>0) {
                for(let gameCode in this.remoteDepositInfoResult.gameInfoJson) {
                    if(gameCodeFilter.indexOf(gameCode)>=0) {
                        if(Object.keys(this.remoteDepositInfoResult.gameInfoJson[gameCode]).length > 0) {
                            this.programData.gameInfoJson[gameCode] = this.remoteDepositInfoResult.gameInfoJson[gameCode]
                        }
                    }
                }
            }
            
            // 判斷是否自動帶入遊戲選項
            if(this.autoSelectFromCookie.isAutoSelect==true
                && this.autoSelectFromCookie.selectGameCodeComplete==false) { // 依照cookie資訊自動帶入遊戲選項
                this.autoSelectFromCookie.selectGameCodeComplete = true;
                this.domSelectGame(this.autoSelectFromCookie.cookieGamecode);
            }
            else if(this.autoSelectFromUrl.isAutoSelect==true
                && this.autoSelectFromUrl.gameCode!=null) { // 依照url參數自動帶入遊戲選項
                if(this.programData.gameInfoJson.hasOwnProperty(this.autoSelectFromUrl.gameCode)) {
                    this.domSelectGame(this.autoSelectFromUrl.gameCode);
                }
                this.clearUrlAutoSelectData(100)
            }
        },



        // 初始化遊戲相關(ex: 遊戲、角色、伺服器、...etc)
        clearGameDataByStepNum(num) {
            this.ajaxMutex.getApkPayMethodsActionKey = ""
            this.ajaxMutex.getApkDepositPidsActionKey = ""

            // 初始化遊戲選項時
            if(num >= 40) {
                this.programData.gameInfoJson = {}
                this.userDepositData.gameCode = ""
            }
            
            // 玩家選取了畫面上的遊戲時
            if(num >= 39) {
                this.programData.serverGroupInfoJson = {}
                this.programData.invoice.requiredCashflowSupplierNum = []

                // 玩家選取的資料
                this.userDepositData.serverGroupId = ""
            }
            
            // 玩家選取了畫面上的伺服器分區時，初始化伺服器相關資料
            if(num >= 38) {
                this.programData.serverInfoJson = {}
            }
            
            // 玩家選取了畫面上的伺服器時，初始化遊戲角色相關資料
            if(num >= 37) {
                this.userDepositData.gameServerNum = ""
                this.userDepositData.gameServerName = ""
                this.programData.roleInfoJson = {}
            }
            
            // 玩家選取了畫面上的伺服器時，初始化遊戲角色相關資料
            if(num >= 36) {
                this.userDepositData.gameRoleId = ""
                this.userDepositData.gameRoleName = ""
                this.userDepositData.gameRoleObj = ""
            }
        },
        
        

        // 初始化儲值相關(ex: 儲值品項、金流商、...etc)
        clearDepositDataByStepNum(num=999) {
            // 初始化資料
            if(num >= 100) {
                // 清空API取得的儲值品項
                this.getApkDepositPidsActionResult.currencyDepositItemInfoArr = []
                this.getApkDepositPidsActionResult.bundleDepositItemInfoArr = []

                this.programData.depositTypeArr = []
                this.programData.cashflowSupplierCategoryJson = {}
                this.programData.cashflowSupplierJson = {}
            }

            // 玩家畫面上選取儲值類型時
            if(num >= 21) {
                this.programData.depositItemInfoArr = []
                this.programData.depositAdapter = null

                // 清除玩家選取的資料
                this.userDepositData.depositItemInfoArr = []
                this.userDepositData.depositType = ""
            }
            
            // 玩家選取了畫面上儲值品項名稱時
            if(num >= 20) {
                let isDomIsSelect = false
                let isDomCanSelect = false

                // 取消選取畫面上所有儲值品項名稱
                this.changeDomIsSelectAndDomCanSelect_depositItemInfoArr(isDomIsSelect)

                // 取消金流群組的domIsSelect與domCanSelect
                this.changeDomIsSelectAndDomCanSelect_cashflowSupplierCategoryJson(isDomIsSelect, isDomCanSelect)

                // 清除禮包品項購買期限提示
                this.domPrompt.depositItemInfoPurchasePeriod = ""

                // 清除玩家儲值品項資訊的陣列資料
                this.userDepositData.integrateCashflowSupplierJson = ""

                // 清除玩家儲值品項金額加總
                this.userDepositData.totalTwdAmount = 0
                this.userDepositData.totalUsdAmount = 0
            }

            // 玩家選取了畫面上金流群組時
            if(num >= 19) {
                let isDomIsSelect = false
                let isDomCanSelect = false

                // 取消金流群組的domIsSelect
                this.changeDomIsSelectAndDomCanSelect_cashflowSupplierCategoryJson(isDomIsSelect)
                
                // 取消金流商的domIsSelect與domCanSelect
                this.changeDomIsSelectAndDomCanSelect_cashflowSupplierJson(isDomIsSelect, isDomCanSelect)


                // 清除玩家儲值資料
                this.userDepositData.cashflowSupplierCategory = ""
            }

            // 玩家選取了畫面上金流商時
            if(num >= 18) {
                let isDomIsSelect = false
                let isDomCanSelect = false
                
                // 取消金流商的domIsSelect
                this.changeDomIsSelectAndDomCanSelect_cashflowSupplierJson(isDomIsSelect)
                
                // 取消電信商的domIsSelect與domCanSelect
                this.changeDomIsSelectAndDomCanSelect_cashflowSupplierJson_vendorJson(isDomIsSelect, isDomCanSelect)

                // 清除玩家儲值資料
                this.userDepositData.cashflowSupplier = ""
            }

            // 玩家選取電信商
            if(num >= 17) {
                // 取消電信商的domIsSelect
                let isDomIsSelect = false
                this.changeDomIsSelectAndDomCanSelect_cashflowSupplierJson_vendorJson(isDomIsSelect)

                // 清除玩家儲值資料
                this.userDepositData.vendor = ""
                this.userDepositData.depositItme = ""
            }
        },
        
        
        
        clearUrlAutoSelectData(num) {
            if(num >= 100) {
                this.autoSelectFromUrl.isAutoSelect = false
            }
            if(num >= 1) {
                this.autoSelectFromUrl.gameCode = null
            }
        },



        genCashflowSupplierCategoryObj() {
            return {
                "cashflowSupplierCategoryName": null,
                "cashflowSupplierNumArr": [],
                "logo": null,
                "domDisplayName": null,
                "domCanSelect": false,
                "domIsSelect": false,
                "domSortOrder": 99999
            }
        },



        genVendorObj() {
            return {
                "vendorName": null,
                "domTagRadioId": null,
                "domTagRadioName": null,
                "domCanSelect": false,
                "domIsSelect": false
            }
        },


        // 用cashflowSupplierNumArr產生cashflowSupplierCategoryJsonrKey
        genCashflowSupplierCategoryJsonKeyByCashflowSupplierNumArr(cashflowSupplierNumArr = []) {
            return `_${cashflowSupplierNumArr.join("_")}_`
        },



        // 用cashflowSupplierNum產生cashflowSupplierCategoryJsonrKey
        genCashflowSupplierCategoryJsonKeyByCashflowSupplierNum(cashflowSupplierNum = null) {
            if(typeof(cashflowSupplierNum)=="number" && cashflowSupplierNum > 0) {
                return `_${cashflowSupplierNum}_`
            }
            return null
        },



        // 根據傳入isDomIsSelect, isDomCanSelect參數，變更programData.cashflowSupplierCategoryJson中的domIsSelect與domCanSelect
        changeDomIsSelectAndDomCanSelect_cashflowSupplierCategoryJson(isDomIsSelect=null, isDomCanSelect=null) {
            for(let cashflowSupplierCategoryKey in this.programData.cashflowSupplierCategoryJson) {
                if(isDomIsSelect != null) {
                    this.programData.cashflowSupplierCategoryJson[cashflowSupplierCategoryKey]["domIsSelect"] = isDomIsSelect
                }
                if(isDomCanSelect != null) {
                    this.programData.cashflowSupplierCategoryJson[cashflowSupplierCategoryKey]["domCanSelect"] = isDomCanSelect
                }
            }
        },
        
        
        
        // 根據傳入isDomIsSelect, isDomCanSelect參數，變更programData.cashflowSupplierJson中的domIsSelect與domCanSelect
        changeDomIsSelectAndDomCanSelect_cashflowSupplierJson(isDomIsSelect=null, isDomCanSelect=null) {
            for(let cashflowSupplierKey in this.programData.cashflowSupplierJson) {
                if(isDomIsSelect != null) {
                    this.programData.cashflowSupplierJson[cashflowSupplierKey]["domIsSelect"] = isDomIsSelect
                }
                if(isDomCanSelect != null) {
                    this.programData.cashflowSupplierJson[cashflowSupplierKey]["domCanSelect"] = isDomCanSelect
                }
            }
        },
        
        
        
        // 根據傳入isDomIsSelect, isDomCanSelect參數，變更programData.cashflowSupplierJson底下vendorJson中的domIsSelect與domCanSelect
        changeDomIsSelectAndDomCanSelect_cashflowSupplierJson_vendorJson(isDomIsSelect=null, isDomCanSelect=null) {
            // 逐一取出金流商底下的電信商，依照傳入的isDomIsSelect, isDomCanSelect參數變更電信商的domIsSelect, domCanSelect
            for(let cashflowSupplierJsonKey in this.programData.cashflowSupplierJson) { // 逐一取出金流商
                let cashflowSupplierObj = this.programData.cashflowSupplierJson[cashflowSupplierJsonKey]
                // 逐一取出金流商底下所有的電信商
                for(let vendorJsonKey in cashflowSupplierObj.vendorJson) {
                    let vendorObj = cashflowSupplierObj["vendorJson"][vendorJsonKey]
                    if(isDomIsSelect != null) {
                        vendorObj["domIsSelect"] = isDomIsSelect
                    }
                    if(isDomCanSelect != null) {
                        vendorObj["domCanSelect"] = isDomCanSelect
                    }
                }
            }
        },



        // 依照金流商num變更programData.cashflowSupplierCategoryJson，讓金流群組在畫面上可選(domCanSelect=true, domIsSelect=false)
        changeDomCanSelectAndDomIsSelectByCashflowSupplierNum_cashflowSupplierCategoryJson(cashflowSupplierNum) {
            // 是否變更了cashflowSupplierCategoryJson中的資料
            let isChange = false

            // 用儲值品項的金流商num找出cashflowSupplierCategoryJsonKey
            let cashflowSupplierCategoryJsonKey = this.findCashflowSupplierCategoryJsonKeyByCashflowSupplierNum(cashflowSupplierNum)
            if(cashflowSupplierCategoryJsonKey == null) {
                return false
            }

            // 依照cashflowSupplierCategoryJsonKey變更programData.cashflowSupplierCategoryJson的domIsSelect和domCanSelect
            if(this.programData.cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey]) {
                isChange = true
                
                // 讓金流群組在畫面上可選
                this.programData.cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey]["domCanSelect"] = true
                this.programData.cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey]["domIsSelect"] = false
            }

            return isChange
        },
        
        
        
        // 根據傳入isDomIsSelect, isDomCanSelect參數，變更programData.depositItemInfoArr中每個儲值品項資訊的domIsSelect與domCanSelect
        changeDomIsSelectAndDomCanSelect_depositItemInfoArr(isDomIsSelect=null, isDomCanSelect=null) {
            for(let i=0; i<this.programData.depositItemInfoArr.length; i++) {
                if(isDomIsSelect != null) {
                    this.programData.depositItemInfoArr[i]["domIsSelect"] = isDomIsSelect
                }
                if(isDomCanSelect != null) {
                    this.programData.depositItemInfoArr[i]["domCanSelect"] = isDomCanSelect
                }
            }
        },



        // 更新上方背景圖
        async updateTopBackgroundImg(i18n = this.$i18n) {
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale, "storeBackendSetting/getDepositTopBackgroundImgUrl");
            console.log(imageUrl);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        },



        // 玩家選取了遊戲
        async domSelectGame(selectGameCode=undefined) {
            console.log("domSelectGame");
            this.clearGameDataByStepNum(39);
            this.clearDepositDataByStepNum()

            if(selectGameCode !== undefined)
                this.userDepositData.gameCode = selectGameCode
            else
                return
            
            // 整理出要show在畫面上的伺服器分區
            // 確認gameCode存在，進行後續相關處理
            if(selectGameCode !== ""
               && this.programData.gameInfoJson.hasOwnProperty(selectGameCode))
            {
                // 整理出伺服器分區
                let ajaxGetAllServerRoleInfoActionResult = await this.ajaxGetAllServerRoleInfoAction()
                if(ajaxGetAllServerRoleInfoActionResult != true) { // 若ajax無法取得角色&原廠伺服器對照資料，則用remoteDepositInfoResult的資料
                    for(let serverGroupId in this.remoteDepositInfoResult.gameInfoJson[selectGameCode]["serverGroups"]) {                
                        this.programData.serverGroupInfoJson[serverGroupId] = this.remoteDepositInfoResult.gameInfoJson[selectGameCode]['serverGroups'][serverGroupId]
                    }
                }

                // 將膽英文不給網頁儲值，刪除英文版伺服器分區
                if(selectGameCode == "jiangdan") {
                    delete this.programData.serverGroupInfoJson[1]
                }

                // 判斷若伺服器分區只有一個，則自動帶入
                let selectServerGroup = null
                if(Object.keys(this.programData.serverGroupInfoJson).length == 1) {
                    selectServerGroup = Object.keys(this.programData.serverGroupInfoJson)[0]
                }
                
                // 判斷是否有cookie資訊需要自動帶入伺服器分區
                if(this.autoSelectFromCookie.isAutoSelect==true && this.autoSelectFromCookie.selectGameServerGroupComplete==false) {
                    this.autoSelectFromCookie.selectGameServerGroupComplete = true;
                    selectServerGroup = this.autoSelectFromCookie.serverGroupId;
                }

                // 自動帶入伺服器分區
                if(selectServerGroup!=null) {
                    this.domSelectServerGroup(selectServerGroup);
                }
            }
        },



        // 玩家選取了伺服器分區
        domSelectServerGroup(selectServerGroupId=undefined) {
            console.log("domSelectServerGroup");
            this.clearGameDataByStepNum(38);
            this.clearDepositDataByStepNum()

            if(selectServerGroupId !== undefined)
                this.userDepositData.serverGroupId = selectServerGroupId;
            else
                return
            
            // 整理出要show在畫面上的伺服器
            if(selectServerGroupId !== "") {
                // 將伺服器分區底下的所有伺服器資料逐一取出後整理
                let serverArr = this.programData.serverGroupInfoJson[this.userDepositData.serverGroupId]["server"]
                for(let i=0; i<serverArr.length; i++) {
                    let serverObj = serverArr[i]
                    let serverPk = serverObj["serverPk"]
                    this.programData.serverInfoJson[serverPk] = serverObj
                }
                
                // 判斷是否自動帶入儲值選項
                if(this.autoSelectFromCookie.isAutoSelect==true && this.autoSelectFromCookie.selectGameServerComplete==false) {
                    this.autoSelectFromCookie.selectGameServerComplete = true;
                    this.domSelectServer(this.autoSelectFromCookie.gameServerNum)
                }
            }
        },



        // 玩家選取了伺服器
        async domSelectServer(selectGameServerNum=undefined) {
            console.log("domSelectServer");
            this.clearGameDataByStepNum(37);
            this.clearDepositDataByStepNum()

            if(this.remoteDepositInfoResult.userInfo.mmiInfoJson[this.userDepositData.gameCode]==undefined) {
                alert(this.$i18n.t('deposit.NotFindRole'));
                return;
            }

            if(selectGameServerNum !== undefined)
                this.userDepositData.gameServerNum = selectGameServerNum
            else
                return

            if(this.userDepositData.gameServerNum !== "") {
                // 取得伺服器名稱
                const serverArr = this.programData.gameInfoJson[this.userDepositData.gameCode]["serverGroups"][this.userDepositData.serverGroupId]["server"]
                for(let i in serverArr) {
                    let serverObj = serverArr[i]
                    if(serverObj["gameServerNum"] == this.userDepositData.gameServerNum) {
                        this.userDepositData.gameServerName = serverObj["gameServerName"]
                    }
                }

                let roleArr = []
                // 從server object取看看是否有roleInfoList
                for(let serverPk in this.programData.serverInfoJson) {
                    let serverObj = this.programData.serverInfoJson[serverPk]
                    if(serverObj["gameServerNum"] == this.userDepositData.gameServerNum
                       && serverObj["roleInfoList"] != undefined
                       && Array.isArray(serverObj["roleInfoList"])) {
                        roleArr = serverObj["roleInfoList"]
                    }
                }

                // roleArr沒資料，透過gameCode與gameServerNum進行ajax取得角色資料
                if(roleArr.length == 0) {
                    let ajaxResult = await this.ajaxGetMobileGameRoleInfoAction(this.userDepositData.gameCode, this.userDepositData.gameServerNum)
                    if(ajaxResult["result"]=="success"
                       && ajaxResult["msg"]!=undefined
                       && Array.isArray(ajaxResult["msg"])) {
                        roleArr = ajaxResult["msg"]
                    }
                }

                if(roleArr.length == 0) {
                    alert(this.$i18n.t('deposit.NotFindRole'));
                    return
                }
                else {
                    for(let i=0; i<roleArr.length; i++) {
                        let account = roleArr[i]["account"]
                        this.$set(this.programData.roleInfoJson, account, roleArr[i])
                    }

                    // 判斷是否自動帶入角色選項
                    if(this.autoSelectFromCookie.isAutoSelect==true && this.autoSelectFromCookie.selectRoleIdComplete==false) {
                        this.autoSelectFromCookie.selectRoleIdComplete = true;
                        // 逐一取出角色資訊，與cookie的角色資訊做比對
                        for(let roleInfoJsonKey in this.programData.roleInfoJson) {
                            if(this.autoSelectFromCookie.cookieRid == roleInfoJsonKey
                                && this.autoSelectFromCookie.cookieRname == this.programData.roleInfoJson[roleInfoJsonKey]["name"]) {
                                this.domSelectGameRole(this.programData.roleInfoJson[roleInfoJsonKey])
                                break
                            }
                        }
                    }
                }
            }
        },



        // 玩家選取遊戲角色
        async domSelectGameRole(selectGameRoleObj=undefined) {
            console.log("domSelectGameRole");

            this.clearDepositDataByStepNum()
            this.clearGameDataByStepNum(36)

            if(selectGameRoleObj!=undefined && selectGameRoleObj != "") {
                this.userDepositData.gameRoleObj = selectGameRoleObj
                this.userDepositData.gameRoleId = selectGameRoleObj["account"]
                this.userDepositData.gameRoleName = selectGameRoleObj["name"]
                    
                // ajax取得金流商、儲值品項資訊，並依照這些資料做後續處理
                if(true) {
                    // 開啟loading動畫
                    this.domControl.ajaxApi.getApkPayMethodsAction.showLoading = true
                    this.domControl.ajaxApi.getApkDepositPidsAction.showLoading = true

                    // ajax取得儲值品項與金流商
                    let ajaxGetApkDepositPidsActionResult = await this.ajaxGetApkDepositPidsAction()
                    let ajaxGetApkPayMethodsActionResult = await this.ajaxGetApkPayMethodsAction()
                    console.log(ajaxGetApkDepositPidsActionResult);
                    console.log(ajaxGetApkPayMethodsActionResult);

                    // ajax取得儲值品項與金流商成功，對資料進行後續處理
                    if(ajaxGetApkDepositPidsActionResult == this.ajaxMutex.getApkDepositPidsActionKey
                       && ajaxGetApkPayMethodsActionResult == this.ajaxMutex.getApkPayMethodsActionKey)
                    {
                        this.initCashflowSupplierData()
                        this.domSelectDepositType(this.userDepositData.depositType)

                        // 關閉loading動畫
                        this.domControl.ajaxApi.getApkPayMethodsAction.showLoading = false
                        this.domControl.ajaxApi.getApkDepositPidsAction.showLoading = false
                        console.log(`最後選用: ajaxGetApkDepositPidsActionResult = ${ajaxGetApkDepositPidsActionResult}`);
                        console.log(`最後選用: ajaxGetApkPayMethodsActionResult = ${ajaxGetApkPayMethodsActionResult}`);
                    }
                    else if(this.ajaxMutex.getApkDepositPidsActionKey == "" 
                       && this.ajaxMutex.getApkPayMethodsActionKey == "")
                    {
                        // 關閉loading動畫
                        this.domControl.ajaxApi.getApkPayMethodsAction.showLoading = false
                        this.domControl.ajaxApi.getApkDepositPidsAction.showLoading = false
                    }
                }
            }
        },



        // 玩家點選畫面上的儲值類型
        domSelectDepositType(selectDepositType) {
            console.log("domSelectDepositType");
            this.clearDepositDataByStepNum(21)
            this.userDepositData.depositType = selectDepositType
            
            // Adapte
            if(this.userDepositData.depositType == "Currency")
                this.programData.depositAdapter = new DepositAdapter.CurrencyDepositAdapt(this.userDepositData.depositType)
            else if(this.userDepositData.depositType == "Bundle") {
                this.programData.depositAdapter = new DepositAdapter.BundleDepositAdapt(this.userDepositData.depositType)
            }
            else {
                throw "error"
            }
            
            // 初始化儲值商品資訊
            this.initDepositItemInfoJson()
        },



        // 玩家點選了畫面上的儲值品項名稱
        domSelectDepositItemName(selectDepositItemInfoObj) {
            console.log("domSelectDepositItemName");

            // 依照流程初始化資料
            this.clearDepositDataByStepNum(20)

            // 依照玩家選擇的儲值品項資訊做處理
            let result = this.programData.depositAdapter.selectDepositItemName(this.userDepositData.depositItemInfoArr, selectDepositItemInfoObj)
            if(result["isSuccess"] == true) {

                // 記錄玩家選取的儲值品項資訊
                this.userDepositData.depositItemInfoArr = result["depositItemInfoArr"]

                // 記錄整合出的金流商，每一組金流商都可以支付depositItemInfoArr中的所有儲值品項資訊
                this.userDepositData.integrateCashflowSupplierJson = result["integrateCashflowSupplierJson"]

                // 用integrateCashflowSupplierJson判斷哪些金流群組需要在畫面上可選(domCanSelect=true, domIsSelect=false)
                for(let integrateCashflowSupplierJsonKey in this.userDepositData.integrateCashflowSupplierJson) {
                    let cashflowSupplierNum = this.userDepositData.integrateCashflowSupplierJson[integrateCashflowSupplierJsonKey]["cashflowSupplierNum"]
                    this.changeDomCanSelectAndDomIsSelectByCashflowSupplierNum_cashflowSupplierCategoryJson(cashflowSupplierNum)
                }

                // 依照玩家選取的儲值品項資訊，1.修改儲值品項資訊domIsSelect=true、2.儲值品項金額加總
                for(let i in this.userDepositData.depositItemInfoArr) {
                    // 玩家選取的儲值品項資訊
                    let userDepositItemInfoObj = this.userDepositData.depositItemInfoArr[i]
                    // 畫面上的儲值品項資訊的屬性若與玩家選取的相同，則1.domIsSelect=true、2.儲值品項金額加總
                    for(let j in this.programData.depositItemInfoArr) {
                        let depositItemInfoObj = this.programData.depositItemInfoArr[j]
                        if(userDepositItemInfoObj["itemName"] == depositItemInfoObj["itemName"]
                           && userDepositItemInfoObj["referenceName"] == depositItemInfoObj["referenceName"]
                           && userDepositItemInfoObj["twAmount"] == depositItemInfoObj["twAmount"]) {
                            depositItemInfoObj["domIsSelect"] = true

                            // 頁面要顯示台幣的關係，若儲值品項資訊的twAmount有值，則用twAmount，沒有才用amount
                            let twdAmount = 0
                            let usdAmount = 0
                            if(userDepositItemInfoObj["twAmount"] == 0) {
                                twdAmount = userDepositItemInfoObj["amount"]
                            }
                            else {
                                twdAmount = userDepositItemInfoObj["twAmount"]
                                usdAmount = userDepositItemInfoObj["amount"]
                            }
                            this.userDepositData.totalTwdAmount += twdAmount
                            this.userDepositData.totalUsdAmount += usdAmount
                            break
                        }
                    }
                }

                /**
                 * 判斷儲值品項資訊的domCanSelect是否需要修改
                 * 1.玩家沒有選擇任何一個儲值品項資訊，則所有儲值品項資訊domCanSelect=true
                 * 2.玩家有選擇儲值品項資訊，則domIsSelect=false的儲值品項資訊，判斷底下的儲值品項是否可被整合金流商支付，若不行則domCanSelect=false
                 * 註:
                 * 傳入function的參數如果有變動，vue data也會跟著變動，因為是reference的關係，也因此不需要return資料再進一步處理
                 */
                this.programData.depositAdapter.changeDepositItemInfoDomCanSeletByUserNotSelected(
                    this.userDepositData.depositItemInfoArr,
                    this.programData.depositItemInfoArr,
                    this.userDepositData.integrateCashflowSupplierJson
                )

                // Currency的儲值品項資訊若有購買期限(endTime)，則提示
                if(this.userDepositData.depositType == this.depositTypeSetting.typeObj.Currency.codeName
                   && this.userDepositData.depositItemInfoArr.length == 1) {
                    let depositItemInfo = this.userDepositData.depositItemInfoArr[0]
                    // 判斷有購買期限(endTime)，且大於0，代表需要提示
                    if(depositItemInfo["endTime"] != undefined
                       && isNaN(depositItemInfo["endTime"]) == false
                       && parseInt(depositItemInfo["endTime"]) > 0)
                    {
                        const depositItemPurchasePeriodTs = parseInt(depositItemInfo["endTime"])
                        this.domPrompt.depositItemInfoPurchasePeriod = TimeUtil.getdateAndTimeAndGMTTimezoneFromTimestamp(depositItemPurchasePeriodTs)
                    }
                }

                this.domDivSlideUp_cashflowSuppliers()
            }
        },



        // 玩家點選了畫面上的金流群組
        domSelectCashflowSupplierCategory(cashflowSupplierCategoryIndex, selectCashflowSupplierCategoryObj) {
            console.log("domSelectCashflowSupplierCategory");
            
            // 玩家沒有選取儲值商品資訊就選取金流群組，直接return
            if(this.userDepositData.depositItemInfoArr.length == 0)
                return

            // 不能選取的金流群組直接return
            if(selectCashflowSupplierCategoryObj["domCanSelect"] == false)
                return

            // 初始化資料
            this.clearDepositDataByStepNum(19)

            /**
             * 用玩家選擇的金流群組底下的金流去比對integrateCashflowSupplierJson key的前半部，若有符合則該金流商變成可選
             */
            let hasCashflowSupplier = false
            // 將已整合能支付的金流商key合併成一行
            let integrateCashflowSupplierJsonKeyOneLine = Object.keys(this.userDepositData.integrateCashflowSupplierJson).join("&")
            // 逐一取得金流群組底下的金流商，製作部分key，比對若為integrateCashflowSupplierJsonKeyOneLine的子字串，讓該金流商在畫面上可選擇
            for(let i in selectCashflowSupplierCategoryObj["cashflowSupplierNumArr"]) {
                // 取得金流商num
                let selectCashflowSupplierNum = selectCashflowSupplierCategoryObj["cashflowSupplierNumArr"][i]
                // 金流商num製作成integrateCashflowSupplierJson的部分key
                let partitionIntegrateCashflowSupplierJsonKey = this.programData.depositAdapter.proto_genPartitionIntegrateCashflowSupplierJsonKey_cashflowSupplierNum(selectCashflowSupplierNum)
                // 部分key若為integrateCashflowSupplierJsonKeyOneLine子字串，代表該金流商可在畫面上供選擇
                if(integrateCashflowSupplierJsonKeyOneLine.indexOf(partitionIntegrateCashflowSupplierJsonKey)>=0) {
                    this.programData.cashflowSupplierJson[selectCashflowSupplierNum]["domCanSelect"] = true
                    hasCashflowSupplier = true
                }
            }

            // 儲值品項有金流商可支付，做後續處理
            if(hasCashflowSupplier) {
                // 金流群組改為已選
                selectCashflowSupplierCategoryObj["domIsSelect"] = true

                // 記錄玩家選取的金流群組
                this.userDepositData.cashflowSupplierCategory = selectCashflowSupplierCategoryObj

                // divSlide - 玩家選擇金流群組時要做對應的slideToggle
                this.domDivSlide_whenDomSelectCashflowSupplierCategory(cashflowSupplierCategoryIndex, selectCashflowSupplierCategoryObj)

                // 只有一個金流商，自動選取
                if(selectCashflowSupplierCategoryObj["cashflowSupplierNumArr"].length == 1) {
                    let cashflowSupplierNum = selectCashflowSupplierCategoryObj["cashflowSupplierNumArr"][0]
                    this.domSelectCashflowSupplier(cashflowSupplierCategoryIndex, this.programData.cashflowSupplierJson[cashflowSupplierNum])
                }
            }
        },



        // divSlide - 玩家選擇金流群組時要做對應的slideToggle
        domDivSlide_whenDomSelectCashflowSupplierCategory(cashflowSupplierCategoryIndex, selectCashflowSupplierCategoryObj) {
            // divSlide - 收起所有金流群組底下的所有金流商，除了玩家選擇的金流商群組
            this.domDivSlideUp_cashflowSuppliers([cashflowSupplierCategoryIndex])
                

            // cashflowSuppliers element id
            let cashflowSuppliersEleId = this.domEleId_genCashflowEleId(this.constants.cashflow.cashflowSuppliers, cashflowSupplierCategoryIndex)

            // 依照金流群組底下有幾個金流商的數目進行不同的操作
            if(selectCashflowSupplierCategoryObj["cashflowSupplierNumArr"].length != 1) {
                // divSlide - 收起所有金流群組下所有金流商底下的所有電信商
                for(let cashflowSupplierCategoryJsonKey in this.programData.cashflowSupplierCategoryJson) {
                    this.domDivSlideUp_cashflowVendors(cashflowSupplierCategoryJsonKey)
                }
                // divSlide - 金流商綜合區塊進行slideToggle
                $(`#${cashflowSuppliersEleId}`).slideToggle("fast");
            }
            else { // 只有一個金流商
                // 金流商只有一個，直接變更金流商綜合區塊display
                let cashflowSuppliersEle = document.querySelector(`#${cashflowSuppliersEleId}`)
                if(cashflowSuppliersEle != null) {
                    if(cashflowSuppliersEle.style["display"] == "none") {
                        cashflowSuppliersEle.style["display"] = "block"
                    }
                    else {
                        setTimeout(() => {
                            cashflowSuppliersEle.style["display"] = "none"
                        }, 200);
                    }
                }
            }
        },



        // 玩家選取了金流商
        domSelectCashflowSupplier(selectCashflowSupplierCategoryIndex, selectCashflowSupplierObj, event=null) {
            console.log("domSelectCashflowSupplier");

            // 點選的金流商若borderColor為transparent，直接return
            // 註: 此情況在金流群組下只有一個金流商，該金流商有電信商，因此金流商相關div需隱藏(或呈現透明)，只顯示電信商
            if(event!=null && event.constructor.name=="PointerEvent" && event.target.style["borderColor"]=="transparent")
                return
            
            // 沒有玩家支付金流群組就選擇金流商，直接return
            if(this.userDepositData.cashflowSupplierCategory == "")
                return

            // 不能選取的金流商直接return
            if(selectCashflowSupplierObj["domCanSelect"] == false)
                return

            // 初始化資料
            this.clearDepositDataByStepNum(18)

            /**
             * 判斷選取的金流商與底下的電信商是否可支付選取的儲值品項，若可支付
             * 1.記錄金流商
             * 2.若有電信商，則改為可選取
             */
            let hasCashflowSupplier = false
            // 金流商num
            let selectCashflowSupplierNum = selectCashflowSupplierObj["num"]
            // 用選取的金流商&電信商(若有的話)組出的key，判斷是否被包含在integrateCashflowSupplierJson中，若有，則代表此金流商可支付儲值品項
            if(Object.keys(selectCashflowSupplierObj["vendorJson"]).length==0) { // 金流商底下沒有電信商
                // 用選取的金流商num組出key
                let selectCashflowSupplierJsonKey = this.programData.depositAdapter.proto_genIntegrateCashflowSupplierJsonKey(selectCashflowSupplierNum, "")
                // 判斷是否被包含
                if(this.userDepositData.integrateCashflowSupplierJson[selectCashflowSupplierJsonKey] != undefined) {
                    // 金流商可支付儲值品項
                    hasCashflowSupplier = true
                }
            }
            else { // 金流商底下有電信商
                for(let vendorJsonKey in selectCashflowSupplierObj["vendorJson"]) {
                    // 用選取的金流商num與電信商組出key
                    let selectCashflowSupplierJsonKey = this.programData.depositAdapter.proto_genIntegrateCashflowSupplierJsonKey(selectCashflowSupplierNum, vendorJsonKey)
                    // 判斷是否被包含
                    if(this.userDepositData.integrateCashflowSupplierJson[selectCashflowSupplierJsonKey] != undefined) {
                        // 金流商可支付儲值品項
                        hasCashflowSupplier = true
                        // 電信商改為可選取
                        this.programData.cashflowSupplierJson[selectCashflowSupplierNum]["vendorJson"][vendorJsonKey]["domCanSelect"] = true
                    }
                }
            }

            /**
             * 選擇的金流商可支付儲值品項資訊底下的某一個儲值品項，做以下處理
             * 1.記錄玩家選取的金流商
             * 2.金流商改為已選取
             */
            if(hasCashflowSupplier) {
                // 1.記錄玩家選取的金流商
                this.userDepositData.cashflowSupplier = selectCashflowSupplierObj
                // 2.金流商改為已選取
                selectCashflowSupplierObj["domIsSelect"] = true
                // 3.玩家選擇金流商時要做對應的slideToggle
                this.domDivSlide_whenDomSelectCashflowSupplier(selectCashflowSupplierCategoryIndex, selectCashflowSupplierNum)
            }
        },



        // divSlide - 玩家選擇金流商時要做對應的slideToggle
        domDivSlide_whenDomSelectCashflowSupplier(selectCashflowSupplierCategoryIndex, selectCashflowSupplierNum) {
            // divSlide - 所有金流群組下所有金流商底下的所有電信商都收起，除了玩家選擇的金流商底下的電信商不動作
            for(let cashflowSupplierCategoryJsonKey in this.programData.cashflowSupplierCategoryJson) {
                if(cashflowSupplierCategoryJsonKey != selectCashflowSupplierCategoryIndex) {
                    this.domDivSlideUp_cashflowVendors(cashflowSupplierCategoryJsonKey)
                }
                else {
                    this.domDivSlideUp_cashflowVendors(selectCashflowSupplierCategoryIndex, [selectCashflowSupplierNum])
                }
            }
                

            // divSlide - 玩家選擇的金流商底下的電信商進行slideToggle
            let cashflowVendorsEleId = this.domEleId_genCashflowEleId(this.constants.cashflow.vendors, selectCashflowSupplierNum)
            if(document.querySelector(`#${cashflowVendorsEleId}`) != null) {
                $(`#${cashflowVendorsEleId}`).slideToggle("fast");
            }
        },



        // 玩家選取了電信商
        domSelectVendor(selectVendorObj) {
            console.log("domSelectVendor");
            
            // 沒有玩家支付金流商就選擇電信商，直接return
            if(this.userDepositData.cashflowSupplier == "")
                return

            // 不能選取的電信商直接return
            if(selectVendorObj["domCanSelect"] == false)
                return

            // 初始化資料
            this.clearDepositDataByStepNum(17)

            // 用選取的金流商num與電信商組出key
            let selectCashflowSupplierNum = this.userDepositData.cashflowSupplier["num"]
            let selectVendorName = selectVendorObj["vendorName"]
            let selectCashflowSupplierJsonKey = this.programData.depositAdapter.proto_genIntegrateCashflowSupplierJsonKey(selectCashflowSupplierNum, selectVendorName)

            // 判斷若每個儲值品項資訊底下都會有一個儲值品項可透過玩家選擇的金流商進行支付，則canDepositFlag=true
            let canDepositFlag = true
            for(let i in this.userDepositData.depositItemInfoArr) {
                // 若儲值品項資訊底下有一儲值品項可支付，則canDepositItemFlag=true
                let canDepositItemFlag = false
                let userDepositItemArr = this.userDepositData.depositItemInfoArr[i]["itemArr"]
                for(let j in userDepositItemArr) {
                    let userDepositItem = userDepositItemArr[j]
                    let userCashflowSupplierJsonKey = this.programData.depositAdapter.proto_genIntegrateCashflowSupplierJsonKey(userDepositItem["FK_CASHFLOW_SUPPLIER"], userDepositItem["VENDOR"])
                    if(userCashflowSupplierJsonKey == selectCashflowSupplierJsonKey) {
                        canDepositItemFlag = true
                        break
                    }
                }

                // 若儲值品項資訊底下沒有任一儲值品項可支付，則canDepositFlag=false
                if(canDepositItemFlag == false) {
                    canDepositFlag = false
                    break
                }
            }

            if(canDepositFlag == true) {
                this.userDepositData.vendor = selectVendorObj["vendorName"]
                selectVendorObj["domIsSelect"] = true
            }
        },
        
        
        
        // 選取電子發票
        domSelectInvoiceType() {
            // checkBox只能勾選一個
            if(this.programData.invoice.invoiceCheckValue.length>1) {
                this.programData.invoice.invoiceCheckValue.splice(0,1);
            }
            // 記錄選擇
            this.programData.invoice.selectInvoiceValue = this.programData.invoice.invoiceCheckValue[0]
        },



        // 頁面上是否顯示金流商綜合區塊
        domDivShow_cashflowSuppliers(cashflowSupplierCategoryObj) {
            // 根據金流群組可選的情況下，做對應判斷
            let isDisplayFlag = false
            if(cashflowSupplierCategoryObj["domCanSelect"]==true) {
                if(Object.keys(cashflowSupplierCategoryObj["cashflowSupplierNumArr"]).length>1) { // 金流商num arr>1，回傳true
                    isDisplayFlag = true
                }
                else if(Object.keys(cashflowSupplierCategoryObj["cashflowSupplierNumArr"]).length==1) { // cashflowSupplier只有一個，但有vendor，回傳true
                    let cashflowSupplierNum = cashflowSupplierCategoryObj["cashflowSupplierNumArr"][0]
                    if(Object.keys(this.programData.cashflowSupplierJson[cashflowSupplierNum]["vendorJson"]).length>0) {
                        isDisplayFlag = true
                    }
                }
            }
            return isDisplayFlag
        },
        


        // 頁面上是否顯示金流商
        domDivShow_cashflowSupplier(cashflowSupplierCategoryObj) {
            let isDisplayFlag = true
            if(Object.keys(cashflowSupplierCategoryObj["cashflowSupplierNumArr"]).length == 1) {
                let cashflowSupplierNum = cashflowSupplierCategoryObj["cashflowSupplierNumArr"][0]
                if(Object.keys(this.programData.cashflowSupplierJson[cashflowSupplierNum]["vendorJson"].length>0)) {
                    isDisplayFlag = false
                }
            }
            return isDisplayFlag
        },



        // 產生cashflow相關的元素id
        domEleId_genCashflowEleId(prefixName, index) {
            return prefixName + index
        },



        // divSlide - 收起所有金流群組底下的所有金流商，除了特定金流群組以外
        domDivSlideUp_cashflowSuppliers(exclusionCashflowSupplierCategoryJsonKeyArr=[]) {
            console.log('domDivSlideUp_cashflowSuppliers');
            for(let cashflowSupplierCategoryJsonKey in this.programData.cashflowSupplierCategoryJson) {
                if(exclusionCashflowSupplierCategoryJsonKeyArr.indexOf(cashflowSupplierCategoryJsonKey) == -1) {
                    let cashflowSuppliersEleId = this.domEleId_genCashflowEleId(this.constants.cashflow.cashflowSuppliers, cashflowSupplierCategoryJsonKey)
                    if(document.querySelector(`#${cashflowSuppliersEleId}`) != null) {
                        $(`#${cashflowSuppliersEleId}`).slideUp("fast");
                    }
                }
            }
        },



        // divSlide - 收起特定金流群組下所有金流商底下的所有電信商，除了特定金流商以外
        domDivSlideUp_cashflowVendors(cashflowSupplierCategoryJsonKey, exclusionCashflowSupplierNumArr=[]) {
            console.log('domDivSlideUp_cashflowVendors');
            let cashflowSupplierCategoryObj = this.programData.cashflowSupplierCategoryJson[cashflowSupplierCategoryJsonKey]
            let cashflowSupplierNumArr = cashflowSupplierCategoryObj["cashflowSupplierNumArr"]
            for(let i in cashflowSupplierNumArr) {
                let cashflowSupplierNum = cashflowSupplierNumArr[i]
                if(exclusionCashflowSupplierNumArr.indexOf(cashflowSupplierNum) == -1) {
                    let cashflowVendorsEleId = this.domEleId_genCashflowEleId(this.constants.cashflow.vendors, cashflowSupplierNum)
                    if(document.querySelector(`#${cashflowVendorsEleId}`) != null) {
                        $(`#${cashflowVendorsEleId}`).slideUp("fast");
                    }
                }
            }
        },



        // CSS Style - 已選取樣式
        cssStyle_selectedStyle(cssStyle = null) {
            if(cssStyle == null) cssStyle = {}
            cssStyle["border-color"] = this.constants.css.borderColor.selected
            cssStyle["color"] = this.constants.css.color.selected
            return cssStyle
        },


        // CSS Style - 無法選取樣式
        cssStyle_canNotSelectedStyle(cssStyle = null) {
            if(cssStyle == null) cssStyle = {}
            cssStyle["border-color"] = this.constants.css.borderColor.canNotSelect
            cssStyle["color"] = this.constants.css.color.canNotSelect
            return cssStyle
        },



        cssStyleChange_depositItemBtn(depositItemInfoObj) {
            let cssStyle = {}

            if(depositItemInfoObj["domIsSelect"]===true)
                cssStyle = this.cssStyle_selectedStyle(cssStyle)
            else if(depositItemInfoObj["domCanSelect"]===false) {
                cssStyle = this.cssStyle_canNotSelectedStyle(cssStyle)
                cssStyle["cursor"] = "not-allowed"
            }
            
            return cssStyle
        },



        cssStyleChange_cashflowRowDiv(cashflowSupplierCategoryObj) {
            let cssStyle = {}

            if(cashflowSupplierCategoryObj["domIsSelect"]===true)
                cssStyle = this.cssStyle_selectedStyle(cssStyle)
            else if(cashflowSupplierCategoryObj["domCanSelect"]===false)
                cssStyle = this.cssStyle_canNotSelectedStyle(cssStyle)
            
            return cssStyle
        },



        cssStyleChange_cashflowSupplierDiv(cashflowSupplierCategoryObj, cashflowSupplierNum) {
            let cssStyle = {
                "border-color": "",
                "color": "#FFFFFF",
                "margin": "1% 2%"
            }

            if(this.programData.cashflowSupplierJson[cashflowSupplierNum]["domIsSelect"]===true) { // 金流商已被選擇
                if(Object.keys(cashflowSupplierCategoryObj["cashflowSupplierNumArr"]).length==1
                   && Object.keys(this.programData.cashflowSupplierJson[cashflowSupplierNum]["vendorJson"]).length>0) { // 金流群組中的金流商==1 && 金流商有電信商 >> 不顯示
                    cssStyle["border-color"] = "transparent"
                    delete cssStyle["margin"]
                }
                else {
                    cssStyle = this.cssStyle_selectedStyle(cssStyle)
                }
            }
            else {
                if(this.programData.cashflowSupplierJson[cashflowSupplierNum]["domCanSelect"]===false) { // 金流商不能被選擇時
                    cssStyle = this.cssStyle_canNotSelectedStyle(cssStyle)
                }
                else { // 金流商可被選擇
                    delete cssStyle["border-color"]
                }
            }
            
            return cssStyle
        },



        cssStyleChange_cashflowVendorsDiv(cashflowSupplierCategoryObj) {
            let cssStyle = {"display": "block"}

            if(cashflowSupplierCategoryObj["cashflowSupplierNumArr"].length>=1) 
                cssStyle["display"] = "none"
            
            return cssStyle
        },



        cssStyleChange_cashflowVendorDiv(vendorObj) {
            let cssStyle = {"color": "#FFFFFF"}

            if(vendorObj["domIsSelect"]===true)
                cssStyle = this.cssStyle_selectedStyle(cssStyle)
            else if(vendorObj["domCanSelect"]===false)
                cssStyle = this.cssStyle_canNotSelectedStyle(cssStyle)
            
            return cssStyle
        },



        htmlCode_cashflowSupplierPriceBlock(type) {
            let htmlCode = "Error"
            //let regExp = new RegExp(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/, 'g') // 為符合金額顯示，數字每3位就加入一個小數點
            if(type == this.constants.cashflow.price.pleaseSelectDepositItemName) {
                htmlCode = `<div class="cm-depositcenter-deposit2022-cashflow-price-str">${this.$i18n.t("deposit.price.hint.pleaseSelectDepositItem")}</div>`
            }
            else if(type == this.constants.cashflow.price.pleaseSelect) {
                htmlCode = `<div class="cm-depositcenter-deposit2022-cashflow-price-str">${this.$i18n.t("deposit.price.hint.pleaseSelect")}</div>`
            }
            else if(type == this.constants.cashflow.price.showTWDAmount) {
                const TWDAmountFormatter = new Intl.NumberFormat('zh-TW', {
                    style: 'currency',
                    currency: 'TWD',
                    maximumFractionDigits: 0, // 取到個位數，若有個位數以下的數字進行四捨五入至個位數
                });
                htmlCode = `
                    <div class="cm-depositcenter-deposit2022-cashflow-price-str">${this.$i18n.t("deposit.price.hint.price")}</div>
                    <div class="cm-depositcenter-deposit2022-cashflow-price-num">NT${TWDAmountFormatter.format(this.userDepositData.totalTwdAmount)}</div>
                `
            }
            else if(type == this.constants.cashflow.price.showUSDAmount) {
                const USDAmountFormatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });
                htmlCode = `
                    <div class="cm-depositcenter-deposit2022-cashflow-price-str">${this.$i18n.t("deposit.price.hint.price")}</div>
                    <div class="cm-depositcenter-deposit2022-cashflow-price-num">US${USDAmountFormatter.format(this.userDepositData.totalUsdAmount / 100)}</div>
                `
            }
            else if(type == this.constants.cashflow.price.notApplicable) {
                htmlCode = `<div class="cm-depositcenter-deposit2022-cashflow-price-str">${this.$i18n.t("deposit.price.hint.notApplicable")}</div>`
            }
            return htmlCode
        },



        htmlCodeChange_cashflowSupplierCategoryPriceBlockDiv(cashflowSupplierCategoryObj) {
            let htmlCode = ""

            if(Object.keys(this.userDepositData.integrateCashflowSupplierJson).length == 0) {
                htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.pleaseSelectDepositItemName)
            }
            else if(cashflowSupplierCategoryObj["domCanSelect"]===false) { // 金流群組不可選
                htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.notApplicable)
            }
            else { // 金流群組可選
                if(Object.keys(cashflowSupplierCategoryObj["cashflowSupplierNumArr"]).length==1) { // 只有一個金流商
                    let cashflowSupplierNum = cashflowSupplierCategoryObj["cashflowSupplierNumArr"][0]
                    if(Object.keys(this.programData.cashflowSupplierJson[cashflowSupplierNum]["vendorJson"]).length>0) { // 有電信商
                        htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.pleaseSelect)
                    }
                    else { // 沒有電信商
                        htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.showTWDAmount)
                        if(cashflowSupplierCategoryObj["logo"]=="mol" || cashflowSupplierCategoryObj["logo"]=="paypal") {
                            htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.showUSDAmount)
                        }
                    }
                }
                else if(Object.keys(cashflowSupplierCategoryObj["cashflowSupplierNumArr"]).length>1) { // 多個金流商
                    htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.pleaseSelect)
                }
            }
            return htmlCode
        },



        htmlCodeChange_cashflowSupplierPriceBlockDiv(cashflowSupplierNum) {
            let htmlCode = ""
            if(this.programData.cashflowSupplierJson[cashflowSupplierNum]["domCanSelect"]===false) { // 金流商不可選
                htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.notApplicable)
            }
            else { // 金流商可選
                if(Object.keys(this.programData.cashflowSupplierJson[cashflowSupplierNum]["vendorJson"]).length>0) { // 有電信商
                    htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.pleaseSelect)
                }
                else { // 沒有電信商
                    htmlCode = this.htmlCode_cashflowSupplierPriceBlock(this.constants.cashflow.price.showTWDAmount)
                }
            }
            return htmlCode
        },



        // 依照gameCode與accountCreated，透過Ajax取得角色資訊
        async ajaxGetAllServerRoleInfoAction() {
            let self = this;
            let ajaxResult = "";

            let bodyFormData = new FormData();
            bodyFormData.append("gameCode", this.userDepositData.gameCode);
            bodyFormData.append("gameAccountGenerated", this.remoteDepositInfoResult.userInfo.mmiInfoJson[this.userDepositData.gameCode].accountCreated);
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getAllServerRoleInfoAction.shtml",
                data:bodyFormData,
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .catch(function() {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
            });

            if(response!=undefined && response.data!=undefined) {
                if(response.data["result"] != undefined
                   && response.data["result"] == "success"
                   && response.data["msg"] != undefined) {
                    ajaxResult = this.dealWithAjaxAllServerRoleInfo(response.data["msg"])
                }
            }
            return ajaxResult;
        },



        // Ajax取得角色資訊
        async ajaxGetMobileGameRoleInfoAction(gameCode, gameServerNum) {
            let self = this;
            let ajaxResult = "";

            let bodyFormData = new FormData();
            bodyFormData.append("gameCode", gameCode);
            bodyFormData.append("memberMultiIdPk", this.remoteDepositInfoResult.userInfo.mmiInfoJson[gameCode].pk);
            bodyFormData.append("gameAccountGenerated", this.remoteDepositInfoResult.userInfo.mmiInfoJson[gameCode].accountCreated);
            bodyFormData.append("gameServerNum", gameServerNum);
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getMobileGameRoleInfoAction.shtml",
                data:bodyFormData,
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .catch(function() {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
            });

            if(response!=undefined && response.data!=undefined) {
                if(response.data.result!=undefined) {
                    return response.data; // 回傳ajax結果
                }
            }
            return ajaxResult;
        },



        // Ajax取得會員載具資訊
        async ajaxGetInvoiceMemberCarrier() {
            let bodyFormData = new FormData();
            bodyFormData.append("fkMemberMultiId", store.getters['storeMemberInfo/getNum']);

            // Ajax取得載具資訊
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getInvoiceMemberCarrierAction.shtml",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                data: bodyFormData
            })
            .catch(function () {
                console.log('Connection failed!');
            });

            if (response != undefined && response.status == 200 && response.data != undefined) { // ajax成功
                let jsonResult = response.data;
                if(jsonResult.result == "success") {
                    let messageArray = JSON.parse(jsonResult.message); // 字串陣列轉陣列
                    for(let i=0; i<messageArray.length; i++) {
                        let messageObj = messageArray[i];
                        // 核對身分後，將手機載具、自然人憑證、會員載具(個人)的資料記錄下來
                        if(messageObj.fkMemberMultiId == store.getters['storeMemberInfo/getNum']
                            && messageObj.subAccount == store.getters['storeMemberInfo/getAccount']) { // 核對身分
                            // 依照不同的載具，將資料記錄下來
                            if(messageObj.carrierType == this.invoice.personalInvoice.carriers.phoneCarrier.carrierType) { // 手機載具
                                this.programData.invoice.personalInvoice.carriers.phoneCarrier.inputPhoneBarcode = messageObj.carrierId1;
                                this.programData.invoice.personalInvoice.carriers.phoneCarrier.phoneBarcodeReadonly = true;
                            }
                            else if(messageObj.carrierType == this.invoice.personalInvoice.carriers.certificateCarrier.carrierType) { // 自然人憑證
                                this.programData.invoice.personalInvoice.carriers.certificateCarrier.inputCertificate = messageObj.carrierId1;
                                this.programData.invoice.personalInvoice.carriers.certificateCarrier.certificateReadonly = true;
                            }
                            else if(messageObj.carrierType == this.invoice.personalInvoice.carriers.CMCarrier.carrierType) { // 會員載具(個人)
                                this.programData.invoice.personalInvoice.carriers.CMCarrier.inputInvoicePhone = messageObj.invoicePhone;
                                this.programData.invoice.personalInvoice.carriers.CMCarrier.invoicePhoneReadonly = true;
                            }
                        }
                    }
                }
            }
        },



        // Ajax取得付款相關資訊
        async ajaxGetApkPayMethodsAction() {
            console.log('ajaxGetApkPayMethodsAction');
            this.getApkPayMethodsActionResult.cashflowSupplierCategoryArr = []
            this.getApkPayMethodsActionResult.payMethodArr = []

            // post參數
            let bodyFormData = new FormData();
            bodyFormData.append("gameCode", this.userDepositData.gameCode);

            // Ajax取得儲值品項資訊
            let ajaxMutexKey = `gameCode_${new Date().getTime()}`
            this.ajaxMutex.getApkPayMethodsActionKey = ajaxMutexKey
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getApkPayMethodsAction.shtml",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                data: bodyFormData
            })
            .catch(function () {
                console.log('Connection failed!');
            });

            // ajax成功，取出儲值品項資訊
            let getApkPayMethodsSuccessFlag = false // 判斷是否成功取得儲值品項資訊
            if(ajaxMutexKey == this.ajaxMutex.getApkPayMethodsActionKey 
                && response != undefined
                && response.status == 200
                && response.data != ""
                && response.data.hasOwnProperty("cashflowSupplierCategoryArr")
                && response.data.hasOwnProperty("payMethodSetJson"))
            { // ajax成功
                this.getApkPayMethodsActionResult.cashflowSupplierCategoryArr = response.data.cashflowSupplierCategoryArr
                this.getApkPayMethodsActionResult.payMethodArr = response.data.payMethodSetJson
                getApkPayMethodsSuccessFlag = ajaxMutexKey
            }
            
            return getApkPayMethodsSuccessFlag
        },



        // Ajax取得儲值品項資訊
        async ajaxGetApkDepositPidsAction() {
            console.log('ajaxGetApkDepositPidsAction');
            this.getApkDepositPidsActionResult.currencyDepositItemInfoArr = []
            this.getApkDepositPidsActionResult.bundleDepositItemInfoArr = []
            

            // post參數
            let bodyFormData = new FormData();
            bodyFormData.append("gameCode", this.userDepositData.gameCode);
            bodyFormData.append("gameServerNum", this.userDepositData.gameServerNum);
            bodyFormData.append("gameAccountGenerated", this.remoteDepositInfoResult.userInfo.mmiInfoJson[this.userDepositData.gameCode].accountCreated);
            bodyFormData.append("roleId", this.userDepositData.gameRoleId);
            bodyFormData.append("roleName", this.userDepositData.gameRoleName);


            // Ajax取得儲值品項資訊
            let ajaxMutexKey = `gameCode_${new Date().getTime()}`
            this.ajaxMutex.getApkDepositPidsActionKey = ajaxMutexKey
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getApkDepositPidsAction.shtml",
                timeout: 180000, // 因應將膽禮包會較久，設置timeout=3分鐘
                data: bodyFormData
            })
            .catch(function () {
                console.log('Connection failed!');
            });
            


            // ajax成功，取出儲值品項資訊
            let getApkDepositPidsSuccessFlag = false // 判斷是否成功取得儲值品項資訊
            if(ajaxMutexKey == this.ajaxMutex.getApkDepositPidsActionKey
               && response != undefined
               && response.status == 200
               && response.data != "")
            { // ajax成功
                // ajax回來的資料中，其儲值類型與對應儲存這些資料的變數都存在的話，將這些儲值類型底下的相關資訊，儲存到對應的變數中
                let depositTypeNameArr = Object.keys(this.depositTypeSetting.typeObj)
                let depositTypeArr = []
                for(let i in depositTypeNameArr) {
                    let depositTypeName = depositTypeNameArr[i]
                    let attrName = `${depositTypeName.toLowerCase()}DepositItemInfoArr`
                    // 判斷儲值類型與對應儲存的變數都儲存，則資料儲存到變數中
                    if(response.data[depositTypeName] != undefined
                       && this.getApkDepositPidsActionResult[attrName] != undefined
                       && this.depositTypeSetting.typeObj[depositTypeName] != undefined) {
                        this.getApkDepositPidsActionResult[attrName] = response.data[depositTypeName]
                        getApkDepositPidsSuccessFlag = ajaxMutexKey
                        depositTypeArr.push(this.depositTypeSetting.typeObj[depositTypeName])
                    }
                }

                if(getApkDepositPidsSuccessFlag == this.ajaxMutex.getApkDepositPidsActionKey) {
                    this.programData.depositTypeArr = depositTypeArr
                    // 對儲值類型進行排序
                    if(this.programData.depositTypeArr.length >= 2) {
                        this.programData.depositTypeArr.sort((a, b) => {
                            if(a.codeName == this.depositTypeSetting.default) {
                                this.userDepositData.depositType = this.depositTypeSetting.default
                            }
                            return a.order - b.order
                        });
                    }

                    // 預設玩家選擇儲值類型
                    if(this.programData.depositTypeArr.length>=1 && this.userDepositData.depositType=="") {
                        this.userDepositData.depositType = this.programData.depositTypeArr[0].codeName
                    }
                }
            }
            
            return getApkDepositPidsSuccessFlag
        },



        // 透過Ajax在gametaiwan.com設置cookie
        async ajaxSetGametaiwanCookie(depositId) {
            let isSuccess = false;
            let bodyFormData = new FormData();
            bodyFormData.append("depositCookie", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
            bodyFormData.append("depositAccountNum", this.remoteDepositInfoResult.userInfo.mmiInfoJson[this.userDepositData.gameCode].pk);
            bodyFormData.append("depositId", depositId);
            bodyFormData.append("depositFrom", location.protocol + "//" + location.host);
            
            const response = await axios({
                method: "post",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN_GAMETAIWAN + "/all9FunDeposit.shtml",
                data: bodyFormData,
                withCredentials: true,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }} }
            )
            .catch(function(response) {
                //...
            });

            if(response!=undefined && response.data.result != undefined && response.data.result=="success") {
                isSuccess = true;
            }

            return isSuccess;
        },



        // 處理Ajax回來的角色&原廠伺服器的資料
        dealWithAjaxAllServerRoleInfo(ajaxResult) {
            let flag = true
        
            // 判斷透過ajax是否有取得角色&原廠伺服器對應資料
            let ajaxManufactoryServerIdArr = []
            if(flag) {
                if(Object.keys(ajaxResult).length>0) {
                    ajaxManufactoryServerIdArr = Object.keys(ajaxResult).map(ele => parseInt(ele))
                }
                else {
                    flag = false
                }
            }
            
            // ajax回來了角色&原廠伺服器對應資料，依照原廠伺服器id去判斷programData.gameInfoJson中的原廠伺服器id是否符合
            // 若有符合，則該server object留下，並將ajax回來了的角色資料加入server object中
            // 若不符合，則該server object從array中去除
            // 最後將整理好的serverGroupObj存放到programData.serverGroupInfoJson
            if(flag) {
                let serverGroupsObj = JSON.parse(JSON.stringify(this.programData.gameInfoJson[this.userDepositData.gameCode]["serverGroups"]))
                for(let serverGroupId in serverGroupsObj) {
                    // 從serverGroups取得object後，再從object取得server array
                    let serverGroupObj = serverGroupsObj[serverGroupId]
                    let serverArr = serverGroupObj["server"]
        
                    // 判斷manufactoryServerId是否存在於ajax回來的原廠伺服器id array中，若存在，將ajax取得的角色資料加入該server object中
                    let newServerArr = []
                    for(let i in serverArr) {
                        let serverObj = serverArr[i]
                        let manufactoryServerId = serverObj["manufactoryServerId"]
                        // 判斷存在，將ajax回的角色資料加入server object
                        if(ajaxManufactoryServerIdArr.indexOf(manufactoryServerId) > -1) {
                            serverObj["roleInfoList"] = ajaxResult[manufactoryServerId]["roleInfoList"]
                            newServerArr.push(serverObj)
                        }
                    }
        
                    // 新的server array若有資料，表示有ajax回的角色資料，則更新server屬性值；若沒資料，整個serverGroups刪除
                    if(newServerArr.length>0)
                        serverGroupsObj[serverGroupId]["server"] = newServerArr
                    else
                        delete serverGroupsObj[serverGroupId]
                }
                this.programData.serverGroupInfoJson = serverGroupsObj
            }

            return flag
        },

        depositItemExpireFun(depositItemInfoObj) {
            let str = TimeUtil.getdateAndTimeAndGMTTimezoneFromTimestamp(depositItemInfoObj.endTime)
            let strArr = str.split("GMT")
            let strNew = this.$i18n.t('deposit.depositItem.prompt.purchasePeriod') + "<br>" + strArr[0] + "<br>GMT" + strArr[1]
            if(depositItemInfoObj["endTime"] == -1) { // 儲值品項無購買期限
                strNew = `<br>${this.$i18n.t('deposit.depositItem.prompt.noPurchasePeriod')}<br><p></p>`
            }
            return strNew
        },

        // 玩家在畫面上選擇的電子發票資訊，取得後作為儲值用的參數
        getOrderInfoByInvoiceInfo() {
            // 用於最後回傳發票資訊
            let invoiceObj = {}

            // 金流商invoiceRequired!=1直接return
            if(this.userDepositData.cashflowSupplier["invoiceRequired"] != 1) {
                return invoiceObj;
            }

            // 選擇的發票類型，有1.電子發票(個人)、2.電子發票(統編)、3.發票捐贈(伊甸、家扶、創世...等等)
            let invoiceValue = this.programData.invoice.selectInvoiceValue;
            if(invoiceValue == this.invoice.personalInvoice.value) { // 電子發票(個人)
                let carrierValue = this.programData.invoice.personalInvoice.selectCarrierValue;
                if(carrierValue == this.invoice.personalInvoice.carriers.phoneCarrier.value) { // 手機條碼載具
                    // 驗證手機條碼格式
                    let phoneBarcodeErrorMsg = ValidatorUtil.validInvoicePhoneBarcode(this.programData.invoice.personalInvoice.carriers.phoneCarrier.inputPhoneBarcode, { 'req': this.$i18n.t('deposit.invoice.PersonalInvoice.PhoneCarrier.Validate.PhoneBarcode.req'), "format": this.$i18n.t('deposit.invoice.PersonalInvoice.PhoneCarrier.Validate.PhoneBarcode.format') })
                    if(phoneBarcodeErrorMsg!="") { // 發生錯誤
                        alert(phoneBarcodeErrorMsg);
                        return "";
                    }

                    invoiceObj["invoice.invoiceType"] = this.invoice.personalInvoice.invoiceType;
                    invoiceObj["invoice.carrierType"] = this.invoice.personalInvoice.carriers.phoneCarrier.carrierType;
                    invoiceObj["invoice.carrierId1"] = this.programData.invoice.personalInvoice.carriers.phoneCarrier.inputPhoneBarcode;
                    invoiceObj["invoice.carrierId2"] = this.programData.invoice.personalInvoice.carriers.phoneCarrier.inputPhoneBarcode;
                }
                else if(carrierValue == this.invoice.personalInvoice.carriers.certificateCarrier.value) { // 自然人憑證載具
                    // 驗證自然人憑證格式
                    let certificateErrorMsg = ValidatorUtil.validInvoiceCertificate(this.programData.invoice.personalInvoice.carriers.certificateCarrier.inputCertificate, { 'req': this.$i18n.t('deposit.invoice.PersonalInvoice.CertificateCarrier.Validate.Certificate.req'), "format": this.$i18n.t('deposit.invoice.PersonalInvoice.CertificateCarrier.Validate.Certificate.format') })
                    if(certificateErrorMsg!="") { // 發生錯誤
                        alert(certificateErrorMsg);
                        return "";
                    }

                    invoiceObj["invoice.invoiceType"] = this.invoice.personalInvoice.invoiceType;
                    invoiceObj["invoice.carrierType"] = this.invoice.personalInvoice.carriers.certificateCarrier.carrierType;
                    invoiceObj["invoice.carrierId1"] = this.programData.invoice.personalInvoice.carriers.certificateCarrier.inputCertificate;
                    invoiceObj["invoice.carrierId2"] = this.programData.invoice.personalInvoice.carriers.certificateCarrier.inputCertificate;
                }
                else if(carrierValue == this.invoice.personalInvoice.carriers.CMCarrier.value) { // 台遊會員載具
                    // 驗證手機號碼格式
                    let phoneErrorMsg = ValidatorUtil.validInvoice10DigisPhone(this.programData.invoice.personalInvoice.carriers.CMCarrier.inputInvoicePhone, { 'req': this.$i18n.t('deposit.invoice.PersonalInvoice.CMCarrier.Validate.Phone.req'), "format": this.$i18n.t('deposit.invoice.PersonalInvoice.CMCarrier.Validate.Phone.format') })
                    if(phoneErrorMsg!="") { // 發生錯誤
                        alert(phoneErrorMsg);
                        return "";
                    }

                    invoiceObj["invoice.invoiceType"] = this.invoice.personalInvoice.invoiceType;
                    invoiceObj["invoice.carrierType"] = this.invoice.personalInvoice.carriers.CMCarrier.carrierType;
                    invoiceObj["invoice.invoicePhone"] = this.programData.invoice.personalInvoice.carriers.CMCarrier.inputInvoicePhone;
                }
                else {
                    return "";
                }
            }
            else if(invoiceValue == this.invoice.GUINumberInvoice.value) { // 電子發票(統編)
                // 驗證Email格式
                let email = this.programData.invoice.GUINumberInvoice.inputEmail;
                let emailErrorMsg = ValidatorUtil.validEmail(email, { 'req': this.$i18n.t('deposit.invoice.GUINumberInvoice.Validate.Email.req'), "format": this.$i18n.t('deposit.invoice.GUINumberInvoice.Validate.Email.format')});
                if(emailErrorMsg!="") { // 發生錯誤
                    alert(emailErrorMsg);
                    return "";
                }

                // 驗證統一編號
                let GUINumber = this.programData.invoice.GUINumberInvoice.inputGUINumber;
                let GUINumberErrorMsg = ValidatorUtil.validInvoiceGUINumber(GUINumber, { 'req': this.$i18n.t('deposit.invoice.GUINumberInvoice.Validate.GUINumber.req'), "format": this.$i18n.t('deposit.invoice.GUINumberInvoice.Validate.GUINumber.format')});
                if(GUINumberErrorMsg!="") {
                    alert(GUINumberErrorMsg);
                    return "";
                }

                invoiceObj["invoice.carrierType"] = this.invoice.personalInvoice.carriers.CMCarrier.carrierType; // 統編用台遊載具的carrierType
                invoiceObj["invoice.invoiceType"] = this.invoice.GUINumberInvoice.invoiceType;
                invoiceObj["invoice.invoiceEmail"] = email;
                invoiceObj["invoice.invoiceCompanyNumber"] = GUINumber;
            }
            else if(invoiceValue == this.invoice.donationInvoice.value) { // 發票捐贈(伊甸、家扶、創世...等等)
                // 選取的愛心碼
                let loveCode = this.programData.invoice.donationInvoice.selectLoveCode;

                // 判斷選取的愛心碼是否存在
                let isLoveCodeExists = false
                if(this.programData.invoice.donationInvoice.loveCodeJson.hasOwnProperty(loveCode)) {
                    isLoveCodeExists = true
                }

                if(isLoveCodeExists && loveCode!="Other") {
                    invoiceObj["invoice.invoiceType"] = this.invoice.donationInvoice.invoiceType;
                    invoiceObj["invoice.donateNpo"] = loveCode;
                }
                else if(isLoveCodeExists && loveCode=="Other") { // 發票捐贈選擇其他單位
                    let otherLoveCode = this.programData.invoice.donationInvoice.inputOtherLoveCode;

                    // 驗證愛心碼
                    let loveCodeErrorMsg = ValidatorUtil.validInvoiceloveCode(otherLoveCode, { 'req': this.$i18n.t('deposit.invoice.DonationInvoice.Validate.LoveCode.req'), "format": this.$i18n.t('deposit.invoice.DonationInvoice.Validate.LoveCode.format')});
                    if(loveCodeErrorMsg!="") { // 發生錯誤
                        alert(loveCodeErrorMsg);
                        return "";
                    }

                    invoiceObj["invoice.invoiceType"] = this.invoice.donationInvoice.invoiceType;
                    invoiceObj["invoice.donateNpo"] = otherLoveCode;
                }
                else { // 發生錯誤
                    alert(this.$i18n.t('deposit.invoice.DonationInvoice.Validate.LoveCode.selectError'));
                    return "";
                }
            }
            else {
                return "";
            }
            
            return invoiceObj;
        },



        // 處理iFrame_deposit cookie，最終決定是否幫玩家自動帶入儲值資訊
        async dealWithCookie_iframeDeposit(iFrameDepositString) {
            let flag = true

            // 判斷字串是否為空
            if(flag) {
                if(iFrameDepositString==undefined || iFrameDepositString=="") {
                    flag = false
                    return flag;
                }
            }
            
            // 依照字串取出遊戲相關訊息，並做後續處理
            if(flag) {
                let iFrameDepositStringArray = iFrameDepositString.split("_");
                

                // 初步判斷cookie帶有5個值
                if(iFrameDepositStringArray.length != 5) {
                    flag = false
                    return flag
                }

                // 初步判斷cookie的5個值沒有空字串
                for (let i = 0; i <= 4; i++) {
                    let str = iFrameDepositStringArray[i];
                    if (str == undefined || str == "") {
                        flag = false
                        return false;
                    }
                }

                // 取出5個必要參數
                this.autoSelectFromCookie.cookieGamecode = iFrameDepositStringArray[0]; // 遊戲id
                this.autoSelectFromCookie.cookieSid = iFrameDepositStringArray[1];      // 伺服器id
                this.autoSelectFromCookie.cookiePid = iFrameDepositStringArray[2];      // 品項id
                this.autoSelectFromCookie.cookieRid = iFrameDepositStringArray[3];      // 角色id
                this.autoSelectFromCookie.cookieRname = iFrameDepositStringArray[4];    // 角色名稱

                // 取得遊戲資訊
                let jsonGame = this.remoteDepositInfoResult.gameInfoJson[this.autoSelectFromCookie.cookieGamecode];
                if (!ValidatorUtil.isJson(jsonGame)) {
                    flag = false
                    return flag;
                }

                // 取得所有伺服器分區
                let jsonGameServerGroup = jsonGame.serverGroups
                if (!ValidatorUtil.isJson(jsonGameServerGroup)) {
                    flag = false
                    return flag;
                }

                // 依照伺服器id取得對應的伺服器分區
                for (let serverGroupCode in jsonGameServerGroup) {
                    let serverGroup = jsonGameServerGroup[serverGroupCode]

                    if (ValidatorUtil.isJson(serverGroup) && Array.isArray(serverGroup.server)) {
                        let serverArray = serverGroup.server;
                        for (let i = 0; i < serverArray.length; i++) {
                            let serverInfo = serverArray[i];
                            if (serverInfo.manufactoryServerId == this.autoSelectFromCookie.cookieSid) {
                                this.autoSelectFromCookie.gameServerGroupName = serverInfo.serverGroupName;
                                this.autoSelectFromCookie.serverGroupId = serverInfo.serverGroupId;
                                this.autoSelectFromCookie.gameServerNum = serverInfo.gameServerNum;
                                break;
                            }
                        }
                    }
                }
                if (this.autoSelectFromCookie.gameServerGroupName == undefined || this.autoSelectFromCookie.gameServerGroupName == "") {
                    flag = false
                    return flag;
                }

                // 判斷角色id、角色名稱
                let checkRole = false;
                const ajaxGameRoleResponse = await this.ajaxGetMobileGameRoleInfoAction(this.autoSelectFromCookie.cookieGamecode, this.autoSelectFromCookie.gameServerNum);
                if(ajaxGameRoleResponse != "" && ajaxGameRoleResponse.result=="success") {
                    if(Array.isArray(ajaxGameRoleResponse.msg)) {
                        let msgArray = ajaxGameRoleResponse.msg;
                        for(let i=0; i<msgArray.length; i++) {
                            let roleInfo = msgArray[i];
                            if(roleInfo.account==this.autoSelectFromCookie.cookieRid 
                                && roleInfo.name==this.autoSelectFromCookie.cookieRname) { // 判斷角色id、角色名稱
                                checkRole = true;
                            }
                        }
                    }
                }
                if(checkRole == false) {
                    flag = false
                    return flag;
                }
            }

            // 最終判斷是否要自動帶入儲值資訊
            if(flag) {
                if (this.autoSelectFromCookie.cookieGamecode != null && this.autoSelectFromCookie.cookieGamecode != "" &&
                    this.autoSelectFromCookie.cookieSid != null && this.autoSelectFromCookie.cookieSid != "" &&
                    this.autoSelectFromCookie.cookiePid != null && this.autoSelectFromCookie.cookiePid != "" &&
                    this.autoSelectFromCookie.cookieRid != null && this.autoSelectFromCookie.cookieRid != "" &&
                    this.autoSelectFromCookie.cookieRname != null && this.autoSelectFromCookie.cookieRname != "" &&
                    this.autoSelectFromCookie.gameServerGroupName != null && this.autoSelectFromCookie.gameServerGroupName != "" &&
                    this.autoSelectFromCookie.serverGroupId != null && this.autoSelectFromCookie.serverGroupId != "" &&
                    this.autoSelectFromCookie.gameServerNum != null && this.autoSelectFromCookie.gameServerNum >= 0 ) {
                    this.autoSelectFromCookie.isAutoSelect = true;
                }
            }
        },



        // 用金流商num找出金流商群組，未找出則回傳null
        findCashflowSupplierCategoryJsonKeyByCashflowSupplierNum(cashflowSupplierNum) {
            // 欲回傳資訊
            let cashflowSupplierCategoryJsonKey = null

            // 用cashflowSupplierNum尋找cashflowSupplierCategoryJsonrKey
            let partitionCashflowSupplierCategoryJsonrKey = this.genCashflowSupplierCategoryJsonKeyByCashflowSupplierNum(cashflowSupplierNum)
            let cashflowSupplierCategoryJsonKeyArr = Object.keys(this.programData.cashflowSupplierCategoryJson)
            for(let i=0; i<cashflowSupplierCategoryJsonKeyArr.length; i++) {
                let tmpCashflowSupplierCategoryJsonKey = cashflowSupplierCategoryJsonKeyArr[i]
                if(partitionCashflowSupplierCategoryJsonrKey != null
                    && tmpCashflowSupplierCategoryJsonKey.indexOf(partitionCashflowSupplierCategoryJsonrKey)!=-1) {
                    cashflowSupplierCategoryJsonKey = tmpCashflowSupplierCategoryJsonKey
                    break
                }
            }

            return cashflowSupplierCategoryJsonKey
        },



        // 用玩家選擇的支付方式，挑出每個儲值品項資訊底下相同支付方式儲值品項(會是唯一)的pk放進陣列中，最後回傳陣列；若過程判斷發現錯誤則回傳空字串
        getUserSelectDepositItemPkArr() {
            console.log("getUserSelectDepositItemPkArr");

            // 欲回傳變數，記錄每個儲值品項的
            let depositItemPkArr = []

            // 用玩家選擇的支付方式組出integrateCashflowSupplierJsonKey
            let userCashflowSupplierNum = this.userDepositData.cashflowSupplier["num"]
            let userVendor = this.userDepositData.vendor
            let userIntegrateCashflowSupplierJsonKey = this.programData.depositAdapter.proto_genIntegrateCashflowSupplierJsonKey(userCashflowSupplierNum, userVendor)

            // 玩家選擇的支付方式組出的key不在integrateCashflowSupplierJson中表示發生錯誤
            if(this.userDepositData.integrateCashflowSupplierJson[userIntegrateCashflowSupplierJsonKey] == undefined) {
                return ""
            }

            // 每個儲值品項資訊底下存在一個(且唯一)儲值品項能夠被玩家選擇的支付方式支付，將這些儲值品項挑出
            for(let i in this.userDepositData.depositItemInfoArr) {
                let depositItemArr = this.userDepositData.depositItemInfoArr[i]["itemArr"]
                let hasDepositItemFlag = false
                for(let j in depositItemArr) {
                    // 依照儲值品項組出integrateCashflowSupplierJsonKey
                    let depositItemObj = depositItemArr[j]
                    let depositCashflowSupplierNum = depositItemObj["FK_CASHFLOW_SUPPLIER"]
                    let depositVendor = depositItemObj["VENDOR"]
                    let depositIntegrateCashflowSupplierJsonKey = this.programData.depositAdapter.proto_genIntegrateCashflowSupplierJsonKey(depositCashflowSupplierNum, depositVendor)
                    
                    // 判斷儲值品項組出的key 與 玩家選擇支付方式組出的key是否相同
                    if(depositIntegrateCashflowSupplierJsonKey == userIntegrateCashflowSupplierJsonKey) {
                        depositItemPkArr.push(depositItemObj["PK_DEPOSIT_ITEM"])
                        hasDepositItemFlag = true
                        break
                    }
                }

                // 若儲值品項資訊底下的所有儲值品項皆無法被玩家選取的支付方式支付，直接return
                if(hasDepositItemFlag == false) {
                    return ""
                }
            }

            return depositItemPkArr
        },



        // 依照傳入的金流相關資訊(金流群組、金流商、電信商)，從物件取得logo名稱，並產生img element html code
        getPayLogoImgHtmlCode(type, obj) {
            // 取得logo名稱
            let payLogoName = "default"
            if(type == this.constants.cashflow.cashflowCategory) {
                // cashflowSupplierCategoryName屬性有值需特別處理，這些都是API傳來的預設金流商群組
                if(obj["cashflowSupplierCategoryName"] == "信用卡") {
                    payLogoName = "creditcard"
                }
                else if(obj["cashflowSupplierCategoryName"] == "MyCard點數卡") {
                    payLogoName = "mycard"
                }
                else if(obj["cashflowSupplierCategoryName"] == "支付寶") {
                    payLogoName = "alipay"
                }
                else {
                    payLogoName = (obj["logo"]!=null ? obj["logo"] : this.programData.cashflowSupplierJson[obj["cashflowSupplierNumArr"][0]]["logo"])
                }
            }
            else if(type == this.constants.cashflow.cashflowSupplier) {
                payLogoName = obj["logo"]
            }
            else if(type == this.constants.cashflow.vendor) {
                payLogoName = obj["vendorName"]
            }

            // 判斷logo是否存在，不存在使用預設
            if(this.constants.logo.payLogoArr.indexOf(payLogoName)==-1) {
                payLogoName = "default"
            }
            
            // 取得圖片路徑
            let imgPath = require(`@/assets/images/paylogo/${payLogoName}.png`)

            // 產生html code
            let htmlCode = `<div class="d-flex"><img class="cm-depositcenter-deposit2022-cashflow-paylogo" src=${imgPath} alt=""></div>`
            if(this.constants.logo.payLogoJustifyContentCenterArr.indexOf(payLogoName)>-1) {
                htmlCode = `<div class="d-flex justify-content-center"><img class="cm-depositcenter-deposit2022-cashflow-paylogo" src=${imgPath} alt=""></div>`
            }
            
            
            return htmlCode
        },



        // 算出所有儲值品項金額加總
        getDepositItemsTotalAmount() {
            let totalAmount = 0;
            for(let i in this.userDepositData.depositItemInfoArr) {
                let depositItemInfo = this.userDepositData.depositItemInfoArr[i]
                totalAmount += depositItemInfo["amount"]
            }
            totalAmount = (totalAmount==0) ? 999999 : totalAmount // 防呆
            return totalAmount
        },



        clickDepositNormal() {
            this.domControl.showDepositArea = false
            this.domControl.showNormalDeposit = true
        },
        
        
        
        clickDepositCodapay() {
            router.push({name: process.env.VUE_APP_ROUTER_CODAPAY});
        },
        
        
        
        // 我要儲值按鈕
        async clickIWantBtn() {
            // 驗證需要的資料
            let mmiInfoByGameCode = this.remoteDepositInfoResult.userInfo.mmiInfoJson[this.userDepositData.gameCode]
            if(mmiInfoByGameCode == undefined
                || this.userDepositData.cashflowSupplier === ""
                || this.userDepositData.depositItemInfoArr.length == 0
                || this.userDepositData.gameCode === ""
                || this.userDepositData.gameRoleName === ""
                || this.userDepositData.gameRoleId === ""
                || this.userDepositData.serverGroupId === ""
                || this.userDepositData.gameServerNum === "") {
                alert(this.$i18n.t('deposit.PlzEnterFullInfo'));
                return;
            }

            
            // 用玩家選擇的支付方式，挑出玩家挑選每個儲值品項資訊底下相同支付方式(且唯一)儲值品項的pk至陣列
            let userSelectDepositItemPkArr = this.getUserSelectDepositItemPkArr()
            if(userSelectDepositItemPkArr == "") {
                alert(this.$i18n.t('deposit.error.PayMethodCanNotDeposit'));
                return
            }

            // 取得送出訂單所需的儲值品項pk之POST參數
            let orderParam_depositIdInfoObj = this.programData.depositAdapter.getOrderInfoByDepositItemPkArr(userSelectDepositItemPkArr)
            if(orderParam_depositIdInfoObj == "") {
                alert(this.$i18n.t('deposit.error.GetDepositItenPkError'));
                return
            }
            
            // 取得電子發票資訊
            let orderParam_invoiceInfoObj = this.getOrderInfoByInvoiceInfo();
            if(orderParam_invoiceInfoObj == "") { // 玩家若在畫面上填寫的資料有格式錯誤，則會回傳空字串
                return;
            }

            // 取得儲值品項總金額
            let depositItemsTotalAmount = this.getDepositItemsTotalAmount()

             // 檢查若付款方式是信用卡，則檢查金額是否超過3萬上限
            if(this.userDepositData.cashflowSupplier["payMethodName"] == "信用卡" && depositItemsTotalAmount > 30000) {
                alert(this.$i18n.t('deposit.checkOrder.amountHasExceededTWD'));
                return;
            }


            // POST參數
            let bodyFormData = new FormData();
            bodyFormData.append('deposit.memberId', mmiInfoByGameCode.fk);
            bodyFormData.append('deposit.fkMemberMultiId', mmiInfoByGameCode.pk);
            bodyFormData.append('deposit.cashFlowSupplierId', this.userDepositData.cashflowSupplier["num"]);
            bodyFormData.append('deposit.amount', depositItemsTotalAmount);
            bodyFormData.append('gameCode', this.userDepositData.gameCode);
            bodyFormData.append('gameRoleName', this.userDepositData.gameRoleName);
            bodyFormData.append('gameRoleId', this.userDepositData.gameRoleId);
            bodyFormData.append('gameServerGroup', this.userDepositData.serverGroupId);
            bodyFormData.append('gameServerNum', this.userDepositData.gameServerNum);
            bodyFormData.append('cookieValue', CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));

            // 儲值品項POST參數
            for(let key in orderParam_depositIdInfoObj) {
                bodyFormData.append(key, orderParam_depositIdInfoObj[key]);
            }

            // 電子發票POST參數
            if(this.programData.invoice.requiredCashflowSupplierNum.indexOf(this.userDepositData.cashflowSupplier["num"]) >= 0) {
                for(let key in orderParam_invoiceInfoObj) {
                    bodyFormData.append(key, orderParam_invoiceInfoObj[key]);
                }
            }
            else {
                bodyFormData.append("invoice.invoiceType", "");
            }
            

            //建立儲值單
            this.domControl.btn.iWantDeposit.showLoading = true;
            let self = this;
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/CookieStringmdepositAction.shtml",
                data: bodyFormData,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .catch(function(error) {
                var showMsgModalText = self.$i18n.t('deposit.error.FormSubmitFail');
                self.setModalText(showMsgModalText,'');
                self.domControl.btn.iWantDeposit.showLoading = false;
            });

            if(response!=undefined && response.data!=undefined) {
                var data = response.data;
                if (data.result) {
                    let isSetCookieComplete = await self.ajaxSetGametaiwanCookie(data.msg); // 透過Ajax在gametaiwan.com設置cookie
                    if(isSetCookieComplete) {
                        self.goDepositPost(data, mmiInfoByGameCode.fk);
                        return;
                    }
                    else {
                        this.domControl.btn.iWantDeposit.showLoading = false;
                        showMsgModalText = self.$i18n.t('deposit.error.SetGametaiwanCookie');
                        self.setModalText(showMsgModalText,'/');
                        return;
                    }
                }
                else {
                    this.domControl.btn.iWantDeposit.showLoading = false;
                    var showMsgModalText = '';
                    if ('loginStatusError' == data.msg)
                    {
                        showMsgModalText = self.$i18n.t('common.PleaseLogin');
                        self.setModalText(showMsgModalText,'/');
                    }
                    else if ('forbidDeposit' == data.msg)
                    {
                        showMsgModalText = self.$i18n.t('deposit.error.AccountCantDeposit');
                        self.setModalText(showMsgModalText,'/#/contactus?category=depositQA');
                    }
                    else if ('gameRoleInfoNotFound' == data.msg)
                    {
                        showMsgModalText = self.$i18n.t('deposit.NotFindRole');
                        self.setModalText(showMsgModalText,'');
                    }
                    else if ('oneKeyMember' == data.msg)
                    {
                        showMsgModalText = self.$i18n.t('deposit.error.PlzBindAccount');
                        self.setModalText(showMsgModalText,'/');
                    }
                    else
                    {
                        showMsgModalText = self.$i18n.t('deposit.error.ServerBusyNow');
                        self.setModalText(showMsgModalText,'');
                    }
                }
            }
        },
        
        
        
        // 將玩家轉址進行付款
        goDepositPost(paramData, depositPostMemberPk) {
            var myData = paramData;
            $("#depositPostPk").val(myData.msg);
            $("#depositPostCookie").val(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
            $("#depositPostMemberPk").val(depositPostMemberPk);
            $("#form_depositPost").attr("action", process.env.VUE_APP_URL_DOMAIN_LOGIN + "/mobileDepositPostAction.shtml");
            $("#form_depositPost").submit();
        },
        
        
        
        // 用model顯示訊息
        setModalText(content, url) {
            $('#showMsgModalText').html(content);
            $("#showMsgModalText").css("text-align","center");
            //防止按下esc或頁面外時，modal消失的狀況
            $('#showMsgModal').modal({
                keyboard: false,
                backdrop: false
            });
            if(url.length > 0)
            { $('#MsgButton').attr('onclick',"window.location.href='"+url+"'"); }
            $('#showMsgModal').modal('show');
        },
    },
};

</script>